const sources = [{// electricity
    x : 0,
    x2 : 0,
    p : [{
        'type' : 'path',
        'properties' : {
            'class' : 'sources-active-area',
            'd' : 'M0,85.9c0-24.5,19.8-44.3,44.3-44.3s44.3,19.8,44.3,44.3H0z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M28.2,104.9c0.4,0.2,0.7,0.5,0.9,0.8c0.2,0.3,0.3,0.7,0.4,1.1c0.1,0.3,0.1,0.8,0.1,1.4h-4.6c0,0.6,0.2,1.2,0.4,1.5c0.3,0.4,0.7,0.6,1.3,0.6c0.5,0,1-0.2,1.3-0.5c0.2-0.2,0.3-0.5,0.4-0.7h1c0,0.2-0.1,0.5-0.3,0.8s-0.3,0.5-0.5,0.7c-0.3,0.3-0.7,0.5-1.2,0.6c-0.3,0.1-0.5,0.1-0.9,0.1c-0.8,0-1.4-0.3-2-0.9c-0.5-0.6-0.8-1.4-0.8-2.4c0-1,0.3-1.8,0.8-2.5c0.5-0.6,1.3-0.9,2.1-0.9C27.4,104.5,27.8,104.6,28.2,104.9z M28.6,107.3c0-0.5-0.1-0.8-0.3-1.1c-0.3-0.5-0.8-0.8-1.4-0.8c-0.5,0-0.9,0.2-1.2,0.5s-0.5,0.8-0.5,1.3H28.6z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M31.1,102.3h1.1v8.6h-1.1V102.3z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M37.6,104.9c0.4,0.2,0.7,0.5,0.9,0.8c0.2,0.3,0.3,0.7,0.4,1.1c0.1,0.3,0.1,0.8,0.1,1.4h-4.6c0,0.6,0.2,1.2,0.4,1.5c0.3,0.4,0.7,0.6,1.3,0.6c0.5,0,1-0.2,1.3-0.5c0.2-0.2,0.3-0.5,0.4-0.7h1c0,0.2-0.1,0.5-0.3,0.8s-0.3,0.5-0.5,0.7c-0.3,0.3-0.7,0.5-1.2,0.6c-0.3,0.1-0.5,0.1-0.9,0.1c-0.8,0-1.4-0.3-2-0.9c-0.5-0.6-0.8-1.4-0.8-2.4c0-1,0.3-1.8,0.8-2.5c0.5-0.6,1.3-0.9,2.1-0.9C36.7,104.5,37.1,104.6,37.6,104.9z M37.9,107.3c0-0.5-0.1-0.8-0.3-1.1c-0.3-0.5-0.8-0.8-1.4-0.8c-0.5,0-0.9,0.2-1.2,0.5s-0.5,0.8-0.5,1.3H37.9z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M44.5,105c0.4,0.3,0.7,0.9,0.8,1.8h-1c-0.1-0.4-0.2-0.7-0.4-1s-0.6-0.4-1.1-0.4c-0.7,0-1.2,0.3-1.4,1c-0.2,0.4-0.3,1-0.3,1.6c0,0.6,0.1,1.2,0.4,1.6c0.3,0.4,0.7,0.6,1.3,0.6c0.4,0,0.8-0.1,1-0.4s0.4-0.6,0.5-1.1h1c-0.1,0.8-0.4,1.4-0.9,1.8s-1.1,0.6-1.8,0.6c-0.8,0-1.5-0.3-2-0.9s-0.7-1.3-0.7-2.2c0-1.1,0.3-2,0.8-2.6s1.2-0.9,2-0.9C43.5,104.5,44.1,104.7,44.5,105z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M46.6,102.9h1.1v1.8h1v0.9h-1v4.1c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0.1,0.4,0.1c0.1,0,0.1,0,0.2,0s0.1,0,0.2,0v0.8c-0.1,0-0.2,0.1-0.4,0.1s-0.3,0-0.4,0c-0.5,0-0.8-0.1-1-0.4s-0.3-0.6-0.3-1v-4.2h-0.8v-0.9h0.8V102.9z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M49.7,104.7h1v1.1c0.1-0.2,0.3-0.5,0.6-0.8s0.7-0.5,1.1-0.5c0,0,0.1,0,0.1,0s0.1,0,0.2,0v1.1c-0.1,0-0.1,0-0.2,0s-0.1,0-0.2,0c-0.5,0-0.9,0.2-1.2,0.5s-0.4,0.7-0.4,1.2v3.6h-1.1V104.7z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M53.7,102.3h1.1v1.2h-1.1V102.3z M53.7,104.7h1.1v6.2h-1.1V104.7z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M60.5,105c0.4,0.3,0.7,0.9,0.8,1.8h-1c-0.1-0.4-0.2-0.7-0.4-1s-0.6-0.4-1.1-0.4c-0.7,0-1.2,0.3-1.4,1c-0.2,0.4-0.3,1-0.3,1.6c0,0.6,0.1,1.2,0.4,1.6c0.3,0.4,0.7,0.6,1.3,0.6c0.4,0,0.8-0.1,1-0.4s0.4-0.6,0.5-1.1h1c-0.1,0.8-0.4,1.4-0.9,1.8s-1.1,0.6-1.8,0.6c-0.8,0-1.5-0.3-2-0.9s-0.7-1.3-0.7-2.2c0-1.1,0.3-2,0.8-2.6s1.2-0.9,2-0.9C59.5,104.5,60.1,104.7,60.5,105z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M62.4,102.3h1.1v1.2h-1.1V102.3z M62.4,104.7h1.1v6.2h-1.1V104.7z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M65.2,102.9h1.1v1.8h1v0.9h-1v4.1c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0.1,0.4,0.1c0.1,0,0.1,0,0.2,0s0.1,0,0.2,0v0.8c-0.1,0-0.2,0.1-0.4,0.1s-0.3,0-0.4,0c-0.5,0-0.8-0.1-1-0.4s-0.3-0.6-0.3-1v-4.2h-0.8v-0.9h0.8V102.9z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M72.3,104.7h1.2c-0.1,0.4-0.5,1.3-1,2.8c-0.4,1.1-0.7,2-1,2.6c-0.6,1.6-1,2.6-1.3,2.9c-0.2,0.4-0.7,0.5-1.3,0.5c-0.1,0-0.3,0-0.3,0c-0.1,0-0.2,0-0.3-0.1v-1c0.2,0.1,0.3,0.1,0.4,0.1c0.1,0,0.2,0,0.2,0c0.2,0,0.3,0,0.4-0.1c0.1-0.1,0.2-0.1,0.2-0.2c0,0,0.1-0.2,0.2-0.5c0.1-0.3,0.2-0.5,0.3-0.6l-2.3-6.5h1.2l1.7,5.1L72.3,104.7z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M29.4,123.2c0.2,0,0.4-0.1,0.5-0.3c0-0.1,0.1-0.2,0.1-0.4c0-0.4-0.1-0.6-0.4-0.8c-0.3-0.2-0.6-0.2-1.1-0.2c-0.5,0-0.9,0.1-1.2,0.4c-0.1,0.2-0.2,0.4-0.3,0.7h-1c0-0.8,0.3-1.3,0.8-1.6s1-0.5,1.7-0.5c0.7,0,1.3,0.1,1.8,0.4c0.5,0.3,0.7,0.7,0.7,1.3v3.6c0,0.1,0,0.2,0.1,0.3s0.1,0.1,0.3,0.1c0,0,0.1,0,0.2,0s0.1,0,0.2,0v0.8c-0.2,0-0.3,0.1-0.4,0.1s-0.2,0-0.4,0c-0.4,0-0.6-0.1-0.8-0.4c-0.1-0.1-0.1-0.3-0.2-0.6c-0.2,0.3-0.5,0.5-0.9,0.7s-0.8,0.3-1.3,0.3c-0.6,0-1.1-0.2-1.4-0.5c-0.4-0.4-0.6-0.8-0.6-1.3c0-0.6,0.2-1,0.5-1.4c0.4-0.3,0.8-0.5,1.4-0.6L29.4,123.2z M27.1,126c0.2,0.2,0.5,0.3,0.8,0.3c0.4,0,0.7-0.1,1.1-0.3c0.6-0.3,0.9-0.8,0.9-1.4v-0.8c-0.1,0.1-0.3,0.2-0.5,0.2s-0.4,0.1-0.6,0.1l-0.6,0.1c-0.4,0.1-0.7,0.1-0.9,0.2c-0.3,0.2-0.5,0.5-0.5,0.9C26.8,125.6,26.9,125.8,27.1,126z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M32.7,120.7h1v0.9c0.3-0.4,0.6-0.6,0.9-0.8s0.7-0.2,1.1-0.2c0.9,0,1.5,0.3,1.8,0.9c0.2,0.3,0.3,0.8,0.3,1.5v4h-1.1v-4c0-0.4-0.1-0.7-0.2-0.9c-0.2-0.4-0.5-0.6-1-0.6c-0.2,0-0.5,0-0.6,0.1c-0.3,0.1-0.5,0.3-0.8,0.5c-0.2,0.2-0.3,0.4-0.3,0.6s-0.1,0.5-0.1,0.9v3.3h-1.1V120.7z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M42.8,120.9c0.2,0.1,0.4,0.3,0.6,0.6v-3.2h1v8.6h-0.9v-0.9c-0.2,0.4-0.5,0.7-0.9,0.8c-0.3,0.2-0.7,0.3-1.1,0.3c-0.7,0-1.3-0.3-1.8-0.9s-0.8-1.4-0.8-2.3c0-0.9,0.2-1.7,0.7-2.4c0.5-0.7,1.1-1,2-1C42.1,120.6,42.5,120.7,42.8,120.9z M40.4,125.6c0.3,0.5,0.7,0.7,1.4,0.7c0.5,0,0.9-0.2,1.2-0.6s0.5-1,0.5-1.8c0-0.8-0.2-1.4-0.5-1.8s-0.7-0.6-1.2-0.6c-0.5,0-1,0.2-1.3,0.6c-0.3,0.4-0.5,1-0.5,1.8C40,124.6,40.1,125.1,40.4,125.6z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M49.3,118.3h1.1v3.2c0.2-0.3,0.5-0.5,0.7-0.7c0.3-0.2,0.8-0.3,1.3-0.3c0.9,0,1.5,0.3,1.9,1c0.2,0.3,0.3,0.8,0.3,1.4v4h-1.1v-4c0-0.5-0.1-0.8-0.2-1c-0.2-0.3-0.6-0.5-1.1-0.5c-0.4,0-0.8,0.2-1.2,0.5s-0.5,0.9-0.5,1.7v3.3h-1.1V118.3z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M59.9,120.9c0.4,0.2,0.7,0.5,0.9,0.8c0.2,0.3,0.3,0.7,0.4,1.1c0.1,0.3,0.1,0.8,0.1,1.4h-4.6c0,0.6,0.2,1.2,0.4,1.5c0.3,0.4,0.7,0.6,1.3,0.6c0.5,0,1-0.2,1.3-0.5c0.2-0.2,0.3-0.5,0.4-0.7h1c0,0.2-0.1,0.5-0.3,0.8s-0.3,0.5-0.5,0.7c-0.3,0.3-0.7,0.5-1.2,0.6c-0.3,0.1-0.5,0.1-0.9,0.1c-0.8,0-1.4-0.3-2-0.9c-0.5-0.6-0.8-1.4-0.8-2.4c0-1,0.3-1.8,0.8-2.5c0.5-0.6,1.3-0.9,2.1-0.9C59.1,120.5,59.5,120.6,59.9,120.9z M60.3,123.3c0-0.5-0.1-0.8-0.3-1.1c-0.3-0.5-0.8-0.8-1.4-0.8c-0.5,0-0.9,0.2-1.2,0.5s-0.5,0.8-0.5,1.3H60.3z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M66.1,123.2c0.2,0,0.4-0.1,0.5-0.3c0-0.1,0.1-0.2,0.1-0.4c0-0.4-0.1-0.6-0.4-0.8c-0.3-0.2-0.6-0.2-1.1-0.2c-0.5,0-0.9,0.1-1.2,0.4c-0.1,0.2-0.2,0.4-0.3,0.7h-1c0-0.8,0.3-1.3,0.8-1.6s1-0.5,1.7-0.5c0.7,0,1.3,0.1,1.8,0.4c0.5,0.3,0.7,0.7,0.7,1.3v3.6c0,0.1,0,0.2,0.1,0.3s0.1,0.1,0.3,0.1c0,0,0.1,0,0.2,0s0.1,0,0.2,0v0.8c-0.2,0-0.3,0.1-0.4,0.1s-0.2,0-0.4,0c-0.4,0-0.6-0.1-0.8-0.4c-0.1-0.1-0.1-0.3-0.2-0.6c-0.2,0.3-0.5,0.5-0.9,0.7s-0.8,0.3-1.3,0.3c-0.6,0-1.1-0.2-1.4-0.5c-0.4-0.4-0.6-0.8-0.6-1.3c0-0.6,0.2-1,0.5-1.4c0.4-0.3,0.8-0.5,1.4-0.6L66.1,123.2z M63.8,126c0.2,0.2,0.5,0.3,0.8,0.3c0.4,0,0.7-0.1,1.1-0.3c0.6-0.3,0.9-0.8,0.9-1.4v-0.8c-0.1,0.1-0.3,0.2-0.5,0.2s-0.4,0.1-0.6,0.1l-0.6,0.1c-0.4,0.1-0.7,0.1-0.9,0.2c-0.3,0.2-0.5,0.5-0.5,0.9C63.5,125.6,63.6,125.8,63.8,126z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M69.6,118.9h1.1v1.8h1v0.9h-1v4.1c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0.1,0.4,0.1c0.1,0,0.1,0,0.2,0s0.1,0,0.2,0v0.8c-0.1,0-0.2,0.1-0.4,0.1s-0.3,0-0.4,0c-0.5,0-0.8-0.1-1-0.4s-0.3-0.6-0.3-1v-4.2h-0.8v-0.9h0.8V118.9z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M22.9,136.7h1v0.8c0.2-0.3,0.4-0.5,0.7-0.7c0.4-0.2,0.8-0.4,1.3-0.4c0.7,0,1.3,0.3,1.8,0.8s0.7,1.3,0.7,2.3c0,1.4-0.4,2.3-1.1,2.9c-0.5,0.4-1,0.6-1.6,0.6c-0.5,0-0.9-0.1-1.2-0.3c-0.2-0.1-0.4-0.3-0.6-0.6v3.2h-1.1V136.7z M26.9,141.6c0.3-0.4,0.5-1,0.5-1.8c0-0.5-0.1-0.9-0.2-1.3c-0.3-0.7-0.8-1-1.5-1c-0.7,0-1.2,0.4-1.5,1.1c-0.1,0.4-0.2,0.9-0.2,1.5c0,0.5,0.1,0.9,0.2,1.2c0.3,0.6,0.8,1,1.5,1C26.1,142.2,26.5,142,26.9,141.6z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M29.7,136.7h1v1.1c0.1-0.2,0.3-0.5,0.6-0.8s0.7-0.5,1.1-0.5c0,0,0.1,0,0.1,0s0.1,0,0.2,0v1.1c-0.1,0-0.1,0-0.2,0s-0.1,0-0.2,0c-0.5,0-0.9,0.2-1.2,0.5s-0.4,0.7-0.4,1.2v3.6h-1.1V136.7z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M38.2,137.3c0.6,0.5,0.8,1.3,0.8,2.4c0,1-0.2,1.8-0.7,2.5c-0.5,0.7-1.2,1-2.3,1c-0.9,0-1.5-0.3-2-0.9c-0.5-0.6-0.8-1.4-0.8-2.4c0-1.1,0.3-1.9,0.8-2.5c0.5-0.6,1.2-0.9,2.1-0.9C37,136.5,37.7,136.8,38.2,137.3z M37.6,141.5c0.3-0.5,0.4-1.1,0.4-1.8c0-0.6-0.1-1.1-0.3-1.4c-0.3-0.6-0.8-0.9-1.5-0.9c-0.6,0-1.1,0.2-1.4,0.7c-0.3,0.5-0.4,1.1-0.4,1.8c0,0.7,0.1,1.2,0.4,1.7c0.3,0.4,0.7,0.7,1.4,0.7C36.8,142.3,37.3,142,37.6,141.5z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M43.8,136.9c0.2,0.1,0.4,0.3,0.6,0.6v-3.2h1v8.6h-0.9v-0.9c-0.2,0.4-0.5,0.7-0.9,0.8c-0.3,0.2-0.7,0.3-1.1,0.3c-0.7,0-1.3-0.3-1.8-0.9s-0.8-1.4-0.8-2.3c0-0.9,0.2-1.7,0.7-2.4c0.5-0.7,1.1-1,2-1C43.1,136.6,43.5,136.7,43.8,136.9z M41.4,141.6c0.3,0.5,0.7,0.7,1.4,0.7c0.5,0,0.9-0.2,1.2-0.6s0.5-1,0.5-1.8c0-0.8-0.2-1.4-0.5-1.8s-0.7-0.6-1.2-0.6c-0.5,0-1,0.2-1.3,0.6c-0.3,0.4-0.5,1-0.5,1.8C41,140.6,41.1,141.1,41.4,141.6z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M48.1,136.7v4.2c0,0.3,0,0.6,0.1,0.8c0.2,0.4,0.5,0.6,1,0.6c0.7,0,1.2-0.3,1.5-1c0.1-0.4,0.2-0.8,0.2-1.4v-3.1H52v6.3h-1l0-0.9c-0.1,0.2-0.3,0.4-0.5,0.6c-0.4,0.3-0.9,0.5-1.4,0.5c-0.9,0-1.5-0.3-1.8-0.9c-0.2-0.3-0.3-0.7-0.3-1.3v-4.3H48.1z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M57.8,137c0.4,0.3,0.7,0.9,0.8,1.8h-1c-0.1-0.4-0.2-0.7-0.4-1s-0.6-0.4-1.1-0.4c-0.7,0-1.2,0.3-1.4,1c-0.2,0.4-0.3,1-0.3,1.6c0,0.6,0.1,1.2,0.4,1.6c0.3,0.4,0.7,0.6,1.3,0.6c0.4,0,0.8-0.1,1-0.4s0.4-0.6,0.5-1.1h1c-0.1,0.8-0.4,1.4-0.9,1.8s-1.1,0.6-1.8,0.6c-0.8,0-1.5-0.3-2-0.9s-0.7-1.3-0.7-2.2c0-1.1,0.3-2,0.8-2.6s1.2-0.9,2-0.9C56.8,136.5,57.4,136.7,57.8,137z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M59.9,134.9H61v1.8h1v0.9h-1v4.1c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0.1,0.4,0.1c0.1,0,0.1,0,0.2,0s0.1,0,0.2,0v0.8c-0.1,0-0.2,0.1-0.4,0.1s-0.3,0-0.4,0c-0.5,0-0.8-0.1-1-0.4s-0.3-0.6-0.3-1v-4.2H59v-0.9h0.8V134.9z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M63,134.3h1.1v1.2H63V134.3z M63,136.7h1.1v6.2H63V136.7z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M70.2,137.3c0.6,0.5,0.8,1.3,0.8,2.4c0,1-0.2,1.8-0.7,2.5c-0.5,0.7-1.2,1-2.3,1c-0.9,0-1.5-0.3-2-0.9c-0.5-0.6-0.8-1.4-0.8-2.4c0-1.1,0.3-1.9,0.8-2.5c0.5-0.6,1.2-0.9,2.1-0.9C69,136.5,69.7,136.8,70.2,137.3z M69.6,141.5c0.3-0.5,0.4-1.1,0.4-1.8c0-0.6-0.1-1.1-0.3-1.4c-0.3-0.6-0.8-0.9-1.5-0.9c-0.6,0-1.1,0.2-1.4,0.7c-0.3,0.5-0.4,1.1-0.4,1.8c0,0.7,0.1,1.2,0.4,1.7c0.3,0.4,0.7,0.7,1.4,0.7C68.8,142.3,69.3,142,69.6,141.5z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M72.4,136.7h1v0.9c0.3-0.4,0.6-0.6,0.9-0.8s0.7-0.2,1.1-0.2c0.9,0,1.5,0.3,1.8,0.9c0.2,0.3,0.3,0.8,0.3,1.5v4h-1.1v-4c0-0.4-0.1-0.7-0.2-0.9c-0.2-0.4-0.5-0.6-1-0.6c-0.2,0-0.5,0-0.6,0.1c-0.3,0.1-0.5,0.3-0.8,0.5c-0.2,0.2-0.3,0.4-0.3,0.6s-0.1,0.5-0.1,0.9v3.3h-1.1V136.7z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#FDFCFF',
            'd' : 'M1.4,48.6h32.7c0.7,0,1.3-0.6,1.3-1.3s-0.6-1.3-1.3-1.3h-5.9c-0.7,0-1.3-0.6-1.3-1.3v-7.3c0-0.7-0.6-1.3-1.3-1.3H15.1c-0.7,0-1.3,0.6-1.3,1.3v2.2c0,0.7-0.6,1.3-1.3,1.3H8.1c-0.7,0-1.3,0.6-1.3,1.3v1.1c0,0.7-0.6,1.3-1.3,1.3H1.3c-0.8,0-1.3,0.6-1.3,1.4l0.1,1.5C0.2,48.1,0.8,48.6,1.4,48.6'
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'fill' : '#004A7A',
            'points' : '38.7,77.6 30.1,77.6 31.2,26.8 37.6,26.8 '
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'fill' : '#004A7A',
            'points' : '46.1,74.9 40.8,74.9 41.5,43.9 45.4,43.9 '
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'x' : '23.4',
            'y' : '57.4',
            'fill' : '#004A7A',
            'width' : '40.2',
            'height' : '28.9'
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'fill' : '#FDFCFF',
            'points' : '35.6,63 39.5,63 37.1,69 39.6,69 37.3,74.5 40,74.5 35.1,82.3 36.3,76.1 34.1,76.1 35.7,70.4 33.3,70.4 '
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'x' : '49.7',
            'y' : '57.4',
            'fill' : '#00B9ED',
            'width' : '13.9',
            'height' : '28.9'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'x' : '54',
            'y' : '70.6',
            'fill' : '#004A7A',
            'width' : '13.9',
            'height' : '15.7'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'x' : '61.9',
            'y' : '70.6',
            'fill' : '#00B9ED',
            'width' : '13.9',
            'height' : '15.7'
        }
    }]
}, {// commercial
    x : 78,
    x2 : 78,
    p : [{
        'type' : 'path',
        'properties' : {
            'class' : 'sources-active-area',
            'd' : 'M0,85.9c0-24.5,19.8-44.3,44.3-44.3s44.3,19.8,44.3,44.3H0z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M22,105c0.4,0.3,0.7,0.9,0.8,1.8h-1c-0.1-0.4-0.2-0.7-0.4-1s-0.6-0.4-1.1-0.4c-0.7,0-1.2,0.3-1.4,1c-0.2,0.4-0.3,1-0.3,1.6c0,0.6,0.1,1.2,0.4,1.6c0.3,0.4,0.7,0.6,1.3,0.6c0.4,0,0.8-0.1,1-0.4s0.4-0.6,0.5-1.1h1c-0.1,0.8-0.4,1.4-0.9,1.8s-1.1,0.6-1.8,0.6c-0.8,0-1.5-0.3-2-0.9s-0.7-1.3-0.7-2.2c0-1.1,0.3-2,0.8-2.6s1.2-0.9,2-0.9C21,104.5,21.6,104.7,22,105z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M28.4,105.3c0.6,0.5,0.8,1.3,0.8,2.4c0,1-0.2,1.8-0.7,2.5c-0.5,0.7-1.2,1-2.3,1c-0.9,0-1.5-0.3-2-0.9c-0.5-0.6-0.8-1.4-0.8-2.4c0-1.1,0.3-1.9,0.8-2.5c0.5-0.6,1.2-0.9,2.1-0.9C27.2,104.5,27.9,104.8,28.4,105.3z M27.8,109.5c0.3-0.5,0.4-1.1,0.4-1.8c0-0.6-0.1-1.1-0.3-1.4c-0.3-0.6-0.8-0.9-1.5-0.9c-0.6,0-1.1,0.2-1.4,0.7c-0.3,0.5-0.4,1.1-0.4,1.8c0,0.7,0.1,1.2,0.4,1.7c0.3,0.4,0.7,0.7,1.4,0.7C27,110.3,27.5,110,27.8,109.5z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M30.5,104.7h1v0.9c0.2-0.3,0.5-0.5,0.7-0.7c0.3-0.2,0.7-0.4,1.2-0.4c0.5,0,0.9,0.1,1.2,0.4c0.2,0.1,0.3,0.3,0.5,0.6c0.2-0.3,0.5-0.6,0.8-0.7s0.7-0.2,1.1-0.2c0.8,0,1.4,0.3,1.7,0.9c0.2,0.3,0.2,0.8,0.2,1.3v4.2h-1.1v-4.4c0-0.4-0.1-0.7-0.3-0.9s-0.5-0.2-0.8-0.2c-0.4,0-0.8,0.1-1.1,0.4s-0.4,0.7-0.4,1.4v3.7h-1.1v-4.1c0-0.4-0.1-0.7-0.2-0.9c-0.2-0.3-0.5-0.4-0.9-0.4c-0.4,0-0.8,0.2-1.1,0.5s-0.5,0.9-0.5,1.7v3.3h-1.1V104.7z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M40.5,104.7h1v0.9c0.2-0.3,0.5-0.5,0.7-0.7c0.3-0.2,0.7-0.4,1.2-0.4c0.5,0,0.9,0.1,1.2,0.4c0.2,0.1,0.3,0.3,0.5,0.6c0.2-0.3,0.5-0.6,0.8-0.7s0.7-0.2,1.1-0.2c0.8,0,1.4,0.3,1.7,0.9c0.2,0.3,0.2,0.8,0.2,1.3v4.2h-1.1v-4.4c0-0.4-0.1-0.7-0.3-0.9s-0.5-0.2-0.8-0.2c-0.4,0-0.8,0.1-1.1,0.4s-0.4,0.7-0.4,1.4v3.7h-1.1v-4.1c0-0.4-0.1-0.7-0.2-0.9c-0.2-0.3-0.5-0.4-0.9-0.4c-0.4,0-0.8,0.2-1.1,0.5s-0.5,0.9-0.5,1.7v3.3h-1.1V104.7z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M54.4,104.9c0.4,0.2,0.7,0.5,0.9,0.8c0.2,0.3,0.3,0.7,0.4,1.1c0.1,0.3,0.1,0.8,0.1,1.4h-4.6c0,0.6,0.2,1.2,0.4,1.5c0.3,0.4,0.7,0.6,1.3,0.6c0.5,0,1-0.2,1.3-0.5c0.2-0.2,0.3-0.5,0.4-0.7h1c0,0.2-0.1,0.5-0.3,0.8s-0.3,0.5-0.5,0.7c-0.3,0.3-0.7,0.5-1.2,0.6c-0.3,0.1-0.5,0.1-0.9,0.1c-0.8,0-1.4-0.3-2-0.9c-0.5-0.6-0.8-1.4-0.8-2.4c0-1,0.3-1.8,0.8-2.5c0.5-0.6,1.3-0.9,2.1-0.9C53.6,104.5,54,104.6,54.4,104.9z M54.8,107.3c0-0.5-0.1-0.8-0.3-1.1c-0.3-0.5-0.8-0.8-1.4-0.8c-0.5,0-0.9,0.2-1.2,0.5s-0.5,0.8-0.5,1.3H54.8z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M57.2,104.7h1v1.1c0.1-0.2,0.3-0.5,0.6-0.8s0.7-0.5,1.1-0.5c0,0,0.1,0,0.1,0s0.1,0,0.2,0v1.1c-0.1,0-0.1,0-0.2,0s-0.1,0-0.2,0c-0.5,0-0.9,0.2-1.2,0.5s-0.4,0.7-0.4,1.2v3.6h-1.1V104.7z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M65.4,105c0.4,0.3,0.7,0.9,0.8,1.8h-1c-0.1-0.4-0.2-0.7-0.4-1s-0.6-0.4-1.1-0.4c-0.7,0-1.2,0.3-1.4,1c-0.2,0.4-0.3,1-0.3,1.6c0,0.6,0.1,1.2,0.4,1.6c0.3,0.4,0.7,0.6,1.3,0.6c0.4,0,0.8-0.1,1-0.4s0.4-0.6,0.5-1.1h1c-0.1,0.8-0.4,1.4-0.9,1.8s-1.1,0.6-1.8,0.6c-0.8,0-1.5-0.3-2-0.9s-0.7-1.3-0.7-2.2c0-1.1,0.3-2,0.8-2.6s1.2-0.9,2-0.9C64.3,104.5,64.9,104.7,65.4,105z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M67.2,102.3h1.1v1.2h-1.1V102.3z M67.2,104.7h1.1v6.2h-1.1V104.7z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M73.2,107.2c0.2,0,0.4-0.1,0.5-0.3c0-0.1,0.1-0.2,0.1-0.4c0-0.4-0.1-0.6-0.4-0.8c-0.3-0.2-0.6-0.2-1.1-0.2c-0.5,0-0.9,0.1-1.2,0.4c-0.1,0.2-0.2,0.4-0.3,0.7h-1c0-0.8,0.3-1.3,0.8-1.6s1-0.5,1.7-0.5c0.7,0,1.3,0.1,1.8,0.4c0.5,0.3,0.7,0.7,0.7,1.3v3.6c0,0.1,0,0.2,0.1,0.3s0.1,0.1,0.3,0.1c0,0,0.1,0,0.2,0s0.1,0,0.2,0v0.8c-0.2,0-0.3,0.1-0.4,0.1s-0.2,0-0.4,0c-0.4,0-0.6-0.1-0.8-0.4c-0.1-0.1-0.1-0.3-0.2-0.6c-0.2,0.3-0.5,0.5-0.9,0.7s-0.8,0.3-1.3,0.3c-0.6,0-1.1-0.2-1.4-0.5c-0.4-0.4-0.6-0.8-0.6-1.3c0-0.6,0.2-1,0.5-1.4c0.4-0.3,0.8-0.5,1.4-0.6L73.2,107.2z M71,110c0.2,0.2,0.5,0.3,0.8,0.3c0.4,0,0.7-0.1,1.1-0.3c0.6-0.3,0.9-0.8,0.9-1.4v-0.8c-0.1,0.1-0.3,0.2-0.5,0.2s-0.4,0.1-0.6,0.1l-0.6,0.1c-0.4,0.1-0.7,0.1-0.9,0.2c-0.3,0.2-0.5,0.5-0.5,0.9C70.7,109.6,70.8,109.8,71,110z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M76.6,102.3h1.1v8.6h-1.1V102.3z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M81.2,102.3h0.9l-2.7,8.6h-0.9L81.2,102.3z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M20.8,118.3h1.1v3.2c0.2-0.3,0.5-0.5,0.7-0.7c0.3-0.2,0.8-0.3,1.3-0.3c0.9,0,1.5,0.3,1.9,1c0.2,0.3,0.3,0.8,0.3,1.4v4h-1.1v-4c0-0.5-0.1-0.8-0.2-1c-0.2-0.3-0.6-0.5-1.1-0.5c-0.4,0-0.8,0.2-1.2,0.5s-0.5,0.9-0.5,1.7v3.3h-1.1V118.3z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M32.1,121.3c0.6,0.5,0.8,1.3,0.8,2.4c0,1-0.2,1.8-0.7,2.5c-0.5,0.7-1.2,1-2.3,1c-0.9,0-1.5-0.3-2-0.9c-0.5-0.6-0.8-1.4-0.8-2.4c0-1.1,0.3-1.9,0.8-2.5c0.5-0.6,1.2-0.9,2.1-0.9C30.8,120.5,31.5,120.8,32.1,121.3z M31.4,125.5c0.3-0.5,0.4-1.1,0.4-1.8c0-0.6-0.1-1.1-0.3-1.4c-0.3-0.6-0.8-0.9-1.5-0.9c-0.6,0-1.1,0.2-1.4,0.7c-0.3,0.5-0.4,1.1-0.4,1.8c0,0.7,0.1,1.2,0.4,1.7c0.3,0.4,0.7,0.7,1.4,0.7C30.7,126.3,31.2,126,31.4,125.5z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M35.2,120.7v4.2c0,0.3,0,0.6,0.1,0.8c0.2,0.4,0.5,0.6,1,0.6c0.7,0,1.2-0.3,1.5-1c0.1-0.4,0.2-0.8,0.2-1.4v-3.1h1.1v6.3h-1l0-0.9c-0.1,0.2-0.3,0.4-0.5,0.6c-0.4,0.3-0.9,0.5-1.4,0.5c-0.9,0-1.5-0.3-1.8-0.9c-0.2-0.3-0.3-0.7-0.3-1.3v-4.3H35.2z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M41.5,125c0,0.4,0.1,0.6,0.3,0.8c0.3,0.3,0.7,0.5,1.4,0.5c0.4,0,0.7-0.1,1.1-0.3s0.5-0.4,0.5-0.8c0-0.3-0.1-0.5-0.4-0.6c-0.2-0.1-0.5-0.2-0.9-0.3l-0.9-0.2c-0.5-0.1-0.9-0.3-1.2-0.4c-0.5-0.3-0.7-0.7-0.7-1.2c0-0.6,0.2-1.1,0.7-1.4c0.4-0.4,1-0.6,1.7-0.6c1,0,1.6,0.3,2.1,0.8c0.3,0.4,0.4,0.7,0.4,1.1h-1c0-0.2-0.1-0.5-0.3-0.6c-0.2-0.3-0.7-0.4-1.3-0.4c-0.4,0-0.7,0.1-0.9,0.2c-0.2,0.2-0.3,0.4-0.3,0.6c0,0.3,0.1,0.5,0.4,0.7c0.2,0.1,0.4,0.2,0.7,0.3l0.7,0.2c0.8,0.2,1.3,0.4,1.6,0.5c0.4,0.3,0.6,0.7,0.6,1.3c0,0.6-0.2,1-0.6,1.4c-0.4,0.4-1.1,0.6-2,0.6c-0.9,0-1.6-0.2-2-0.6s-0.6-0.9-0.6-1.6H41.5z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M50.7,120.9c0.4,0.2,0.7,0.5,0.9,0.8c0.2,0.3,0.3,0.7,0.4,1.1c0.1,0.3,0.1,0.8,0.1,1.4h-4.6c0,0.6,0.2,1.2,0.4,1.5c0.3,0.4,0.7,0.6,1.3,0.6c0.5,0,1-0.2,1.3-0.5c0.2-0.2,0.3-0.5,0.4-0.7h1c0,0.2-0.1,0.5-0.3,0.8s-0.3,0.5-0.5,0.7c-0.3,0.3-0.7,0.5-1.2,0.6c-0.3,0.1-0.5,0.1-0.9,0.1c-0.8,0-1.4-0.3-2-0.9c-0.5-0.6-0.8-1.4-0.8-2.4c0-1,0.3-1.8,0.8-2.5c0.5-0.6,1.3-0.9,2.1-0.9C49.9,120.5,50.3,120.6,50.7,120.9z M51.1,123.3c0-0.5-0.1-0.8-0.3-1.1c-0.3-0.5-0.8-0.8-1.4-0.8c-0.5,0-0.9,0.2-1.2,0.5s-0.5,0.8-0.5,1.3H51.1z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M53.5,118.3h1.1v3.2c0.2-0.3,0.5-0.5,0.7-0.7c0.3-0.2,0.8-0.3,1.3-0.3c0.9,0,1.5,0.3,1.9,1c0.2,0.3,0.3,0.8,0.3,1.4v4h-1.1v-4c0-0.5-0.1-0.8-0.2-1c-0.2-0.3-0.6-0.5-1.1-0.5c-0.4,0-0.8,0.2-1.2,0.5s-0.5,0.9-0.5,1.7v3.3h-1.1V118.3z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M64.8,121.3c0.6,0.5,0.8,1.3,0.8,2.4c0,1-0.2,1.8-0.7,2.5c-0.5,0.7-1.2,1-2.3,1c-0.9,0-1.5-0.3-2-0.9c-0.5-0.6-0.8-1.4-0.8-2.4c0-1.1,0.3-1.9,0.8-2.5c0.5-0.6,1.2-0.9,2.1-0.9C63.5,120.5,64.2,120.8,64.8,121.3z M64.1,125.5c0.3-0.5,0.4-1.1,0.4-1.8c0-0.6-0.1-1.1-0.3-1.4c-0.3-0.6-0.8-0.9-1.5-0.9c-0.6,0-1.1,0.2-1.4,0.7c-0.3,0.5-0.4,1.1-0.4,1.8c0,0.7,0.1,1.2,0.4,1.7c0.3,0.4,0.7,0.7,1.4,0.7C63.4,126.3,63.9,126,64.1,125.5z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M66.9,118.3H68v8.6h-1.1V118.3z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M73,120.9c0.2,0.1,0.4,0.3,0.6,0.6v-3.2h1v8.6h-0.9v-0.9c-0.2,0.4-0.5,0.7-0.9,0.8c-0.3,0.2-0.7,0.3-1.1,0.3c-0.7,0-1.3-0.3-1.8-0.9s-0.8-1.4-0.8-2.3c0-0.9,0.2-1.7,0.7-2.4c0.5-0.7,1.1-1,2-1C72.3,120.6,72.7,120.7,73,120.9z M70.7,125.6c0.3,0.5,0.7,0.7,1.4,0.7c0.5,0,0.9-0.2,1.2-0.6s0.5-1,0.5-1.8c0-0.8-0.2-1.4-0.5-1.8s-0.7-0.6-1.2-0.6c-0.5,0-1,0.2-1.3,0.6c-0.3,0.4-0.5,1-0.5,1.8C70.2,124.6,70.4,125.1,70.7,125.6z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M30.5,134.3h1.1v3.2c0.2-0.3,0.5-0.5,0.7-0.7c0.3-0.2,0.8-0.3,1.3-0.3c0.9,0,1.5,0.3,1.9,1c0.2,0.3,0.3,0.8,0.3,1.4v4h-1.1v-4c0-0.5-0.1-0.8-0.2-1c-0.2-0.3-0.6-0.5-1.1-0.5c-0.4,0-0.8,0.2-1.2,0.5s-0.5,0.9-0.5,1.7v3.3h-1.1V134.3z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M41.1,136.8c0.4,0.2,0.7,0.5,0.9,0.8c0.2,0.3,0.3,0.7,0.4,1.1c0.1,0.3,0.1,0.8,0.1,1.4H38c0,0.6,0.2,1.2,0.4,1.5c0.3,0.4,0.7,0.6,1.3,0.6c0.5,0,1-0.2,1.3-0.5c0.2-0.2,0.3-0.5,0.4-0.7h1c0,0.2-0.1,0.5-0.3,0.8s-0.3,0.5-0.5,0.7c-0.3,0.3-0.7,0.5-1.2,0.6c-0.3,0.1-0.5,0.1-0.9,0.1c-0.8,0-1.4-0.3-2-0.9c-0.5-0.6-0.8-1.4-0.8-2.4c0-1,0.3-1.8,0.8-2.5c0.5-0.6,1.3-0.9,2.1-0.9C40.2,136.5,40.7,136.6,41.1,136.8z M41.4,139.3c0-0.5-0.1-0.8-0.3-1.1c-0.3-0.5-0.8-0.8-1.4-0.8c-0.5,0-0.9,0.2-1.2,0.5s-0.5,0.8-0.5,1.3H41.4z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M47.2,139.2c0.2,0,0.4-0.1,0.5-0.3c0-0.1,0.1-0.2,0.1-0.4c0-0.4-0.1-0.6-0.4-0.8c-0.3-0.2-0.6-0.2-1.1-0.2c-0.5,0-0.9,0.1-1.2,0.4c-0.1,0.2-0.2,0.4-0.3,0.7h-1c0-0.8,0.3-1.3,0.8-1.6s1-0.5,1.7-0.5c0.7,0,1.3,0.1,1.8,0.4c0.5,0.3,0.7,0.7,0.7,1.3v3.6c0,0.1,0,0.2,0.1,0.3s0.1,0.1,0.3,0.1c0,0,0.1,0,0.2,0s0.1,0,0.2,0v0.8c-0.2,0-0.3,0.1-0.4,0.1s-0.2,0-0.4,0c-0.4,0-0.6-0.1-0.8-0.4c-0.1-0.1-0.1-0.3-0.2-0.6c-0.2,0.3-0.5,0.5-0.9,0.7s-0.8,0.3-1.3,0.3c-0.6,0-1.1-0.2-1.4-0.5c-0.4-0.4-0.6-0.8-0.6-1.3c0-0.6,0.2-1,0.5-1.4c0.4-0.3,0.8-0.5,1.4-0.6L47.2,139.2z M45,142c0.2,0.2,0.5,0.3,0.8,0.3c0.4,0,0.7-0.1,1.1-0.3c0.6-0.3,0.9-0.8,0.9-1.4v-0.8c-0.1,0.1-0.3,0.2-0.5,0.2s-0.4,0.1-0.6,0.1l-0.6,0.1c-0.4,0.1-0.7,0.1-0.9,0.2c-0.3,0.2-0.5,0.5-0.5,0.9C44.7,141.6,44.8,141.8,45,142z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M50.8,134.9h1.1v1.8h1v0.9h-1v4.1c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0.1,0.4,0.1c0.1,0,0.1,0,0.2,0s0.1,0,0.2,0v0.8c-0.1,0-0.2,0.1-0.4,0.1s-0.3,0-0.4,0c-0.5,0-0.8-0.1-1-0.4s-0.3-0.6-0.3-1v-4.2h-0.8v-0.9h0.8V134.9z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M53.9,134.3h1.1v1.2h-1.1V134.3z M53.9,136.7h1.1v6.2h-1.1V136.7z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M56.5,136.7h1v0.9c0.3-0.4,0.6-0.6,0.9-0.8s0.7-0.2,1.1-0.2c0.9,0,1.5,0.3,1.8,0.9c0.2,0.3,0.3,0.8,0.3,1.5v4h-1.1v-4c0-0.4-0.1-0.7-0.2-0.9c-0.2-0.4-0.5-0.6-1-0.6c-0.2,0-0.5,0-0.6,0.1c-0.3,0.1-0.5,0.3-0.8,0.5c-0.2,0.2-0.3,0.4-0.3,0.6s-0.1,0.5-0.1,0.9v3.3h-1.1V136.7z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M66.7,136.9c0.2,0.1,0.4,0.3,0.6,0.6v-0.8h1v5.7c0,0.8-0.1,1.4-0.4,1.9c-0.4,0.9-1.3,1.3-2.5,1.3c-0.7,0-1.2-0.2-1.7-0.5s-0.7-0.8-0.8-1.4h1.1c0.1,0.3,0.2,0.5,0.3,0.7c0.2,0.2,0.6,0.4,1.1,0.4c0.8,0,1.3-0.3,1.6-0.9c0.1-0.3,0.2-0.9,0.2-1.8c-0.2,0.3-0.5,0.6-0.8,0.7c-0.3,0.2-0.7,0.2-1.2,0.2c-0.7,0-1.3-0.2-1.8-0.7s-0.8-1.3-0.8-2.4c0-1.1,0.3-1.9,0.8-2.5s1.1-0.9,1.9-0.9C65.9,136.6,66.3,136.7,66.7,136.9z M66.8,138.1c-0.3-0.4-0.7-0.6-1.2-0.6c-0.7,0-1.2,0.3-1.5,1c-0.1,0.4-0.2,0.9-0.2,1.5c0,0.7,0.1,1.2,0.4,1.6c0.3,0.4,0.7,0.6,1.2,0.6c0.8,0,1.3-0.3,1.6-1c0.2-0.4,0.3-0.8,0.3-1.4C67.3,139,67.2,138.4,66.8,138.1z'
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'fill' : '#00B9ED',
            'points' : '69,86 42.3,86 42.3,74.6 55.9,59.4 69,74.6 '
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'fill' : '#004A7A',
            'points' : '48.8,86 22.1,86 22.1,74.6 35.7,59.4 48.8,74.6 '
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'fill' : '#FDFCFF',
            'points' : '69,74.6 48.8,74.6 35.7,59.4 55.9,59.4 '
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#FDFCFF',
            'd' : 'M53.8,55.5v-8.6c0-1.1-0.9-2-2-2h-2.8c-1.1,0-1.9-0.9-1.9-2v-8.6c0-1.1-0.9-2-2-2H36c-1.1,0-2,0.9-2,2v13.1c0,1.1,0.9,2,2,2h12c1.1,0,1.9,0.9,1.9,2v4.2c0,1,0.7,1.8,1.7,1.9C52.7,57.6,53.8,56.7,53.8,55.5'
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'fill' : '#004A7A',
            'points' : '47.8,55.3 47.8,64.5 51.9,68.7 51.9,55.3 '
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'x' : '51.9',
            'y' : '55.3',
            'fill' : '#00B9ED',
            'width' : '3.5',
            'height' : '13.4'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'x' : '33.1',
            'y' : '67.9',
            'fill' : '#00B9ED',
            'width' : '4.5',
            'height' : '5.5'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'x' : '30.3',
            'y' : '75.9',
            'fill' : '#00B9ED',
            'width' : '4.5',
            'height' : '9.7'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'x' : '35.3',
            'y' : '75.9',
            'fill' : '#00B9ED',
            'width' : '4.5',
            'height' : '9.7'
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'fill' : '#FDFCFF',
            'points' : '30.3,75.9 26.7,79.5 36.1,79.5 39.8,75.9 '
        }
    }]
}, {// industrial
    x : 168,
    x2 : 168,
    p : [{
        'type' : 'path',
        'properties' : {
            'class' : 'sources-active-area',
            'd' : 'M0,85.9c0-24.5,19.8-44.3,44.3-44.3s44.3,19.8,44.3,44.3H0z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#FCFBFF',
            'd' : 'M48.8,45.5h28.4c0.6,0,1.1-0.5,1.1-1.1c0-0.6-0.5-1.1-1.1-1.1h-5.1c-0.6,0-1.1-0.5-1.1-1.1v-6.4c0-0.6-0.5-1.1-1.1-1.1h-9.2c-0.6,0-1.1,0.5-1.1,1.1v1.9c0,0.6-0.5,1.1-1.1,1.1h-3.8c-0.6,0-1.1,0.5-1.1,1.1v1c0,0.6-0.5,1.1-1.1,1.1h-3.7c-0.7,0-1.2,0.6-1.1,1.2l0.1,1.3C47.7,45.1,48.2,45.5,48.8,45.5'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M12.5,102.3h1.1v1.2h-1.1V102.3z M12.5,104.7h1.1v6.2h-1.1V104.7z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M15.2,104.6h1v0.9c0.3-0.4,0.6-0.6,0.9-0.8s0.7-0.2,1.1-0.2c0.9,0,1.5,0.3,1.8,0.9c0.2,0.3,0.3,0.8,0.3,1.5v4h-1.1v-4c0-0.4-0.1-0.7-0.2-0.9c-0.2-0.4-0.5-0.6-1-0.6c-0.2,0-0.5,0-0.6,0.1c-0.3,0.1-0.5,0.3-0.8,0.5c-0.2,0.2-0.3,0.4-0.3,0.6s-0.1,0.5-0.1,0.9v3.3h-1.1V104.6z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M25.3,104.8c0.2,0.1,0.4,0.3,0.6,0.6v-3.2h1v8.6H26V110c-0.2,0.4-0.5,0.7-0.9,0.8c-0.3,0.2-0.7,0.3-1.1,0.3c-0.7,0-1.3-0.3-1.8-0.9s-0.8-1.4-0.8-2.3c0-0.9,0.2-1.7,0.7-2.4c0.5-0.7,1.1-1,2-1C24.6,104.5,25,104.6,25.3,104.8z M23,109.5c0.3,0.5,0.7,0.7,1.4,0.7c0.5,0,0.9-0.2,1.2-0.6s0.5-1,0.5-1.8c0-0.8-0.2-1.4-0.5-1.8s-0.7-0.6-1.2-0.6c-0.5,0-1,0.2-1.3,0.6c-0.3,0.4-0.5,1-0.5,1.8C22.5,108.5,22.7,109.1,23,109.5z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M29.6,104.6v4.2c0,0.3,0,0.6,0.1,0.8c0.2,0.4,0.5,0.6,1,0.6c0.7,0,1.2-0.3,1.5-1c0.1-0.4,0.2-0.8,0.2-1.4v-3.1h1.1v6.3h-1l0-0.9c-0.1,0.2-0.3,0.4-0.5,0.6c-0.4,0.3-0.9,0.5-1.4,0.5c-0.9,0-1.5-0.3-1.8-0.9c-0.2-0.3-0.3-0.7-0.3-1.3v-4.3H29.6z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M35.8,108.9c0,0.4,0.1,0.6,0.3,0.8c0.3,0.3,0.7,0.5,1.4,0.5c0.4,0,0.7-0.1,1.1-0.3s0.5-0.4,0.5-0.8c0-0.3-0.1-0.5-0.4-0.6c-0.2-0.1-0.5-0.2-0.9-0.3l-0.9-0.2c-0.5-0.1-0.9-0.3-1.2-0.4c-0.5-0.3-0.7-0.7-0.7-1.2c0-0.6,0.2-1.1,0.7-1.4c0.4-0.4,1-0.6,1.7-0.6c1,0,1.6,0.3,2.1,0.8c0.3,0.4,0.4,0.7,0.4,1.1h-1c0-0.2-0.1-0.5-0.3-0.6c-0.2-0.3-0.7-0.4-1.3-0.4c-0.4,0-0.7,0.1-0.9,0.2c-0.2,0.2-0.3,0.4-0.3,0.6c0,0.3,0.1,0.5,0.4,0.7c0.2,0.1,0.4,0.2,0.7,0.3l0.7,0.2c0.8,0.2,1.3,0.4,1.6,0.5c0.4,0.3,0.6,0.7,0.6,1.3c0,0.6-0.2,1-0.6,1.4c-0.4,0.4-1.1,0.6-2,0.6c-0.9,0-1.6-0.2-2-0.6s-0.6-0.9-0.6-1.6H35.8z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M41.4,102.9h1.1v1.8h1v0.9h-1v4.1c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0.1,0.4,0.1c0.1,0,0.1,0,0.2,0s0.1,0,0.2,0v0.8c-0.1,0-0.2,0.1-0.4,0.1s-0.3,0-0.4,0c-0.5,0-0.8-0.1-1-0.4s-0.3-0.6-0.3-1v-4.2h-0.8v-0.9h0.8V102.9z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M44.6,104.6h1v1.1c0.1-0.2,0.3-0.5,0.6-0.8s0.7-0.5,1.1-0.5c0,0,0.1,0,0.1,0s0.1,0,0.2,0v1.1c-0.1,0-0.1,0-0.2,0s-0.1,0-0.2,0c-0.5,0-0.9,0.2-1.2,0.5s-0.4,0.7-0.4,1.2v3.6h-1.1V104.6z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M48.5,102.3h1.1v1.2h-1.1V102.3z M48.5,104.7h1.1v6.2h-1.1V104.7z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M54.6,107.1c0.2,0,0.4-0.1,0.5-0.3c0-0.1,0.1-0.2,0.1-0.4c0-0.4-0.1-0.6-0.4-0.8c-0.3-0.2-0.6-0.2-1.1-0.2c-0.5,0-0.9,0.1-1.2,0.4c-0.1,0.2-0.2,0.4-0.3,0.7h-1c0-0.8,0.3-1.3,0.8-1.6s1-0.5,1.7-0.5c0.7,0,1.3,0.1,1.8,0.4c0.5,0.3,0.7,0.7,0.7,1.3v3.6c0,0.1,0,0.2,0.1,0.3s0.1,0.1,0.3,0.1c0,0,0.1,0,0.2,0s0.1,0,0.2,0v0.8c-0.2,0-0.3,0.1-0.4,0.1s-0.2,0-0.4,0c-0.4,0-0.6-0.1-0.8-0.4c-0.1-0.1-0.1-0.3-0.2-0.6c-0.2,0.3-0.5,0.5-0.9,0.7s-0.8,0.3-1.3,0.3c-0.6,0-1.1-0.2-1.4-0.5c-0.4-0.4-0.6-0.8-0.6-1.3c0-0.6,0.2-1,0.5-1.4c0.4-0.3,0.8-0.5,1.4-0.6L54.6,107.1z M52.4,110c0.2,0.2,0.5,0.3,0.8,0.3c0.4,0,0.7-0.1,1.1-0.3c0.6-0.3,0.9-0.8,0.9-1.4v-0.8c-0.1,0.1-0.3,0.2-0.5,0.2S54.2,108,54,108l-0.6,0.1c-0.4,0.1-0.7,0.1-0.9,0.2c-0.3,0.2-0.5,0.5-0.5,0.9C52,109.5,52.1,109.8,52.4,110z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M57.9,102.3H59v8.6h-1.1V102.3z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M67.3,107.1c0.2,0,0.4-0.1,0.5-0.3c0-0.1,0.1-0.2,0.1-0.4c0-0.4-0.1-0.6-0.4-0.8c-0.3-0.2-0.6-0.2-1.1-0.2c-0.5,0-0.9,0.1-1.2,0.4c-0.1,0.2-0.2,0.4-0.3,0.7h-1c0-0.8,0.3-1.3,0.8-1.6s1-0.5,1.7-0.5c0.7,0,1.3,0.1,1.8,0.4c0.5,0.3,0.7,0.7,0.7,1.3v3.6c0,0.1,0,0.2,0.1,0.3s0.1,0.1,0.3,0.1c0,0,0.1,0,0.2,0s0.1,0,0.2,0v0.8c-0.2,0-0.3,0.1-0.4,0.1s-0.2,0-0.4,0c-0.4,0-0.6-0.1-0.8-0.4c-0.1-0.1-0.1-0.3-0.2-0.6c-0.2,0.3-0.5,0.5-0.9,0.7s-0.8,0.3-1.3,0.3c-0.6,0-1.1-0.2-1.4-0.5c-0.4-0.4-0.6-0.8-0.6-1.3c0-0.6,0.2-1,0.5-1.4c0.4-0.3,0.8-0.5,1.4-0.6L67.3,107.1z M65,110c0.2,0.2,0.5,0.3,0.8,0.3c0.4,0,0.7-0.1,1.1-0.3c0.6-0.3,0.9-0.8,0.9-1.4v-0.8c-0.1,0.1-0.3,0.2-0.5,0.2s-0.4,0.1-0.6,0.1l-0.6,0.1c-0.4,0.1-0.7,0.1-0.9,0.2c-0.3,0.2-0.5,0.5-0.5,0.9C64.7,109.5,64.8,109.8,65,110z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M70.6,104.6h1v0.9c0.3-0.4,0.6-0.6,0.9-0.8s0.7-0.2,1.1-0.2c0.9,0,1.5,0.3,1.8,0.9c0.2,0.3,0.3,0.8,0.3,1.5v4h-1.1v-4c0-0.4-0.1-0.7-0.2-0.9c-0.2-0.4-0.5-0.6-1-0.6c-0.2,0-0.5,0-0.6,0.1c-0.3,0.1-0.5,0.3-0.8,0.5c-0.2,0.2-0.3,0.4-0.3,0.6s-0.1,0.5-0.1,0.9v3.3h-1.1V104.6z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M80.7,104.8c0.2,0.1,0.4,0.3,0.6,0.6v-3.2h1v8.6h-0.9V110c-0.2,0.4-0.5,0.7-0.9,0.8c-0.3,0.2-0.7,0.3-1.1,0.3c-0.7,0-1.3-0.3-1.8-0.9s-0.8-1.4-0.8-2.3c0-0.9,0.2-1.7,0.7-2.4c0.5-0.7,1.1-1,2-1C80,104.5,80.4,104.6,80.7,104.8z M78.3,109.5c0.3,0.5,0.7,0.7,1.4,0.7c0.5,0,0.9-0.2,1.2-0.6s0.5-1,0.5-1.8c0-0.8-0.2-1.4-0.5-1.8s-0.7-0.6-1.2-0.6c-0.5,0-1,0.2-1.3,0.6c-0.3,0.4-0.5,1-0.5,1.8C77.9,108.5,78,109.1,78.3,109.5z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M20,121c0.4,0.3,0.7,0.9,0.8,1.8h-1c-0.1-0.4-0.2-0.7-0.4-1s-0.6-0.4-1.1-0.4c-0.7,0-1.2,0.3-1.4,1c-0.2,0.4-0.3,1-0.3,1.6c0,0.6,0.1,1.2,0.4,1.6c0.3,0.4,0.7,0.6,1.3,0.6c0.4,0,0.8-0.1,1-0.4s0.4-0.6,0.5-1.1h1c-0.1,0.8-0.4,1.4-0.9,1.8s-1.1,0.6-1.8,0.6c-0.8,0-1.5-0.3-2-0.9s-0.7-1.3-0.7-2.2c0-1.1,0.3-2,0.8-2.6s1.2-0.9,2-0.9C19,120.4,19.6,120.6,20,121z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M26.4,121.3c0.6,0.5,0.8,1.3,0.8,2.4c0,1-0.2,1.8-0.7,2.5c-0.5,0.7-1.2,1-2.3,1c-0.9,0-1.5-0.3-2-0.9c-0.5-0.6-0.8-1.4-0.8-2.4c0-1.1,0.3-1.9,0.8-2.5c0.5-0.6,1.2-0.9,2.1-0.9C25.2,120.4,25.9,120.7,26.4,121.3z M25.8,125.4c0.3-0.5,0.4-1.1,0.4-1.8c0-0.6-0.1-1.1-0.3-1.4c-0.3-0.6-0.8-0.9-1.5-0.9c-0.6,0-1.1,0.2-1.4,0.7c-0.3,0.5-0.4,1.1-0.4,1.8c0,0.7,0.1,1.2,0.4,1.7c0.3,0.4,0.7,0.7,1.4,0.7C25,126.2,25.5,126,25.8,125.4z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M28.5,120.6h1v0.9c0.3-0.4,0.6-0.6,0.9-0.8s0.7-0.2,1.1-0.2c0.9,0,1.5,0.3,1.8,0.9c0.2,0.3,0.3,0.8,0.3,1.5v4h-1.1v-4c0-0.4-0.1-0.7-0.2-0.9c-0.2-0.4-0.5-0.6-1-0.6c-0.2,0-0.5,0-0.6,0.1c-0.3,0.1-0.5,0.3-0.8,0.5c-0.2,0.2-0.3,0.4-0.3,0.6s-0.1,0.5-0.1,0.9v3.3h-1.1V120.6z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M35.8,124.9c0,0.4,0.1,0.6,0.3,0.8c0.3,0.3,0.7,0.5,1.4,0.5c0.4,0,0.7-0.1,1.1-0.3s0.5-0.4,0.5-0.8c0-0.3-0.1-0.5-0.4-0.6c-0.2-0.1-0.5-0.2-0.9-0.3l-0.9-0.2c-0.5-0.1-0.9-0.3-1.2-0.4c-0.5-0.3-0.7-0.7-0.7-1.2c0-0.6,0.2-1.1,0.7-1.4c0.4-0.4,1-0.6,1.7-0.6c1,0,1.6,0.3,2.1,0.8c0.3,0.4,0.4,0.7,0.4,1.1h-1c0-0.2-0.1-0.5-0.3-0.6c-0.2-0.3-0.7-0.4-1.3-0.4c-0.4,0-0.7,0.1-0.9,0.2c-0.2,0.2-0.3,0.4-0.3,0.6c0,0.3,0.1,0.5,0.4,0.7c0.2,0.1,0.4,0.2,0.7,0.3l0.7,0.2c0.8,0.2,1.3,0.4,1.6,0.5c0.4,0.3,0.6,0.7,0.6,1.3c0,0.6-0.2,1-0.6,1.4c-0.4,0.4-1.1,0.6-2,0.6c-0.9,0-1.6-0.2-2-0.6s-0.6-0.9-0.6-1.6H35.8z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M41.4,118.9h1.1v1.8h1v0.9h-1v4.1c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0.1,0.4,0.1c0.1,0,0.1,0,0.2,0s0.1,0,0.2,0v0.8c-0.1,0-0.2,0.1-0.4,0.1s-0.3,0-0.4,0c-0.5,0-0.8-0.1-1-0.4s-0.3-0.6-0.3-1v-4.2h-0.8v-0.9h0.8V118.9z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M44.6,120.6h1v1.1c0.1-0.2,0.3-0.5,0.6-0.8s0.7-0.5,1.1-0.5c0,0,0.1,0,0.1,0s0.1,0,0.2,0v1.1c-0.1,0-0.1,0-0.2,0s-0.1,0-0.2,0c-0.5,0-0.9,0.2-1.2,0.5s-0.4,0.7-0.4,1.2v3.6h-1.1V120.6z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M49.6,120.6v4.2c0,0.3,0,0.6,0.1,0.8c0.2,0.4,0.5,0.6,1,0.6c0.7,0,1.2-0.3,1.5-1c0.1-0.4,0.2-0.8,0.2-1.4v-3.1h1.1v6.3h-1l0-0.9c-0.1,0.2-0.3,0.4-0.5,0.6c-0.4,0.3-0.9,0.5-1.4,0.5c-0.9,0-1.5-0.3-1.8-0.9c-0.2-0.3-0.3-0.7-0.3-1.3v-4.3H49.6z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M59.4,121c0.4,0.3,0.7,0.9,0.8,1.8h-1c-0.1-0.4-0.2-0.7-0.4-1s-0.6-0.4-1.1-0.4c-0.7,0-1.2,0.3-1.4,1c-0.2,0.4-0.3,1-0.3,1.6c0,0.6,0.1,1.2,0.4,1.6c0.3,0.4,0.7,0.6,1.3,0.6c0.4,0,0.8-0.1,1-0.4s0.4-0.6,0.5-1.1h1c-0.1,0.8-0.4,1.4-0.9,1.8s-1.1,0.6-1.8,0.6c-0.8,0-1.5-0.3-2-0.9s-0.7-1.3-0.7-2.2c0-1.1,0.3-2,0.8-2.6s1.2-0.9,2-0.9C58.3,120.4,58.9,120.6,59.4,121z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M61.4,118.9h1.1v1.8h1v0.9h-1v4.1c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0.1,0.4,0.1c0.1,0,0.1,0,0.2,0s0.1,0,0.2,0v0.8c-0.1,0-0.2,0.1-0.4,0.1s-0.3,0-0.4,0c-0.5,0-0.8-0.1-1-0.4s-0.3-0.6-0.3-1v-4.2h-0.8v-0.9h0.8V118.9z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M64.6,118.3h1.1v1.2h-1.1V118.3z M64.6,120.7h1.1v6.2h-1.1V120.7z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M71.8,121.3c0.6,0.5,0.8,1.3,0.8,2.4c0,1-0.2,1.8-0.7,2.5c-0.5,0.7-1.2,1-2.3,1c-0.9,0-1.5-0.3-2-0.9c-0.5-0.6-0.8-1.4-0.8-2.4c0-1.1,0.3-1.9,0.8-2.5c0.5-0.6,1.2-0.9,2.1-0.9C70.5,120.4,71.2,120.7,71.8,121.3z M71.1,125.4c0.3-0.5,0.4-1.1,0.4-1.8c0-0.6-0.1-1.1-0.3-1.4c-0.3-0.6-0.8-0.9-1.5-0.9c-0.6,0-1.1,0.2-1.4,0.7c-0.3,0.5-0.4,1.1-0.4,1.8c0,0.7,0.1,1.2,0.4,1.7c0.3,0.4,0.7,0.7,1.4,0.7C70.4,126.2,70.9,126,71.1,125.4z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M73.9,120.6h1v0.9c0.3-0.4,0.6-0.6,0.9-0.8s0.7-0.2,1.1-0.2c0.9,0,1.5,0.3,1.8,0.9c0.2,0.3,0.3,0.8,0.3,1.5v4h-1.1v-4c0-0.4-0.1-0.7-0.2-0.9c-0.2-0.4-0.5-0.6-1-0.6c-0.2,0-0.5,0-0.6,0.1c-0.3,0.1-0.5,0.3-0.8,0.5c-0.2,0.2-0.3,0.4-0.3,0.6s-0.1,0.5-0.1,0.9v3.3h-1.1V120.6z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M30.2,139.1c0.2,0,0.4-0.1,0.5-0.3c0-0.1,0.1-0.2,0.1-0.4c0-0.4-0.1-0.6-0.4-0.8c-0.3-0.2-0.6-0.2-1.1-0.2c-0.5,0-0.9,0.1-1.2,0.4c-0.1,0.2-0.2,0.4-0.3,0.7h-1c0-0.8,0.3-1.3,0.8-1.6s1-0.5,1.7-0.5c0.7,0,1.3,0.1,1.8,0.4c0.5,0.3,0.7,0.7,0.7,1.3v3.6c0,0.1,0,0.2,0.1,0.3s0.1,0.1,0.3,0.1c0,0,0.1,0,0.2,0s0.1,0,0.2,0v0.8c-0.2,0-0.3,0.1-0.4,0.1s-0.2,0-0.4,0c-0.4,0-0.6-0.1-0.8-0.4c-0.1-0.1-0.1-0.3-0.2-0.6c-0.2,0.3-0.5,0.5-0.9,0.7s-0.8,0.3-1.3,0.3c-0.6,0-1.1-0.2-1.4-0.5c-0.4-0.4-0.6-0.8-0.6-1.3c0-0.6,0.2-1,0.5-1.4c0.4-0.3,0.8-0.5,1.4-0.6L30.2,139.1z M28,142c0.2,0.2,0.5,0.3,0.8,0.3c0.4,0,0.7-0.1,1.1-0.3c0.6-0.3,0.9-0.8,0.9-1.4v-0.8c-0.1,0.1-0.3,0.2-0.5,0.2s-0.4,0.1-0.6,0.1l-0.6,0.1c-0.4,0.1-0.7,0.1-0.9,0.2c-0.3,0.2-0.5,0.5-0.5,0.9C27.7,141.5,27.8,141.8,28,142z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M37.7,137c0.4,0.3,0.7,0.9,0.8,1.8h-1c-0.1-0.4-0.2-0.7-0.4-1s-0.6-0.4-1.1-0.4c-0.7,0-1.2,0.3-1.4,1c-0.2,0.4-0.3,1-0.3,1.6c0,0.6,0.1,1.2,0.4,1.6c0.3,0.4,0.7,0.6,1.3,0.6c0.4,0,0.8-0.1,1-0.4s0.4-0.6,0.5-1.1h1c-0.1,0.8-0.4,1.4-0.9,1.8s-1.1,0.6-1.8,0.6c-0.8,0-1.5-0.3-2-0.9s-0.7-1.3-0.7-2.2c0-1.1,0.3-2,0.8-2.6s1.2-0.9,2-0.9C36.7,136.4,37.2,136.6,37.7,137z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M39.8,134.9h1.1v1.8h1v0.9h-1v4.1c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0.1,0.4,0.1c0.1,0,0.1,0,0.2,0s0.1,0,0.2,0v0.8c-0.1,0-0.2,0.1-0.4,0.1s-0.3,0-0.4,0c-0.5,0-0.8-0.1-1-0.4s-0.3-0.6-0.3-1v-4.2h-0.8v-0.9h0.8V134.9z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M42.9,134.3H44v1.2h-1.1V134.3z M42.9,136.7H44v6.2h-1.1V136.7z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M46.1,136.6l1.7,5.1l1.7-5.1h1.2l-2.4,6.3h-1.1l-2.3-6.3H46.1z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M51.5,134.3h1.1v1.2h-1.1V134.3z M51.5,136.7h1.1v6.2h-1.1V136.7z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M54.4,134.9h1.1v1.8h1v0.9h-1v4.1c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0.1,0.4,0.1c0.1,0,0.1,0,0.2,0s0.1,0,0.2,0v0.8c-0.1,0-0.2,0.1-0.4,0.1s-0.3,0-0.4,0c-0.5,0-0.8-0.1-1-0.4s-0.3-0.6-0.3-1v-4.2h-0.8v-0.9h0.8V134.9z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M57.5,134.3h1.1v1.2h-1.1V134.3z M57.5,136.7h1.1v6.2h-1.1V136.7z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M64.1,136.8c0.4,0.2,0.7,0.5,0.9,0.8c0.2,0.3,0.3,0.7,0.4,1.1c0.1,0.3,0.1,0.8,0.1,1.4H61c0,0.6,0.2,1.2,0.4,1.5c0.3,0.4,0.7,0.6,1.3,0.6c0.5,0,1-0.2,1.3-0.5c0.2-0.2,0.3-0.5,0.4-0.7h1c0,0.2-0.1,0.5-0.3,0.8s-0.3,0.5-0.5,0.7c-0.3,0.3-0.7,0.5-1.2,0.6c-0.3,0.1-0.5,0.1-0.9,0.1c-0.8,0-1.4-0.3-2-0.9c-0.5-0.6-0.8-1.4-0.8-2.4c0-1,0.3-1.8,0.8-2.5c0.5-0.6,1.3-0.9,2.1-0.9C63.2,136.5,63.7,136.6,64.1,136.8z M64.5,139.3c0-0.5-0.1-0.8-0.3-1.1c-0.3-0.5-0.8-0.8-1.4-0.8c-0.5,0-0.9,0.2-1.2,0.5s-0.5,0.8-0.5,1.3H64.5z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M67.5,140.9c0,0.4,0.1,0.6,0.3,0.8c0.3,0.3,0.7,0.5,1.4,0.5c0.4,0,0.7-0.1,1.1-0.3s0.5-0.4,0.5-0.8c0-0.3-0.1-0.5-0.4-0.6c-0.2-0.1-0.5-0.2-0.9-0.3l-0.9-0.2c-0.5-0.1-0.9-0.3-1.2-0.4c-0.5-0.3-0.7-0.7-0.7-1.2c0-0.6,0.2-1.1,0.7-1.4c0.4-0.4,1-0.6,1.7-0.6c1,0,1.6,0.3,2.1,0.8c0.3,0.4,0.4,0.7,0.4,1.1h-1c0-0.2-0.1-0.5-0.3-0.6c-0.2-0.3-0.7-0.4-1.3-0.4c-0.4,0-0.7,0.1-0.9,0.2c-0.2,0.2-0.3,0.4-0.3,0.6c0,0.3,0.1,0.5,0.4,0.7c0.2,0.1,0.4,0.2,0.7,0.3l0.7,0.2c0.8,0.2,1.3,0.4,1.6,0.5c0.4,0.3,0.6,0.7,0.6,1.3c0,0.6-0.2,1-0.6,1.4c-0.4,0.4-1.1,0.6-2,0.6c-0.9,0-1.6-0.2-2-0.6s-0.6-0.9-0.6-1.6H67.5z'
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'fill' : '#003867',
            'points' : '64.5,75.3 58.6,75.3 59.4,41.2 63.7,41.2 '
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'x' : '16',
            'y' : '66.4',
            'fill' : '#095A9E',
            'width' : '44.3',
            'height' : '19'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'x' : '23.2',
            'y' : '59.4',
            'fill' : '#00A9E7',
            'width' : '37.1',
            'height' : '26'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'x' : '49.7',
            'y' : '68.1',
            'fill' : '#003867',
            'width' : '15.3',
            'height' : '17.3'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'x' : '58.4',
            'y' : '68.1',
            'fill' : '#00A9E7',
            'width' : '15.3',
            'height' : '17.3'
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'fill' : '#003867',
            'points' : '37.7,66.2 37.7,59 30.5,66.2 30.5,59 23.3,66.2 23.2,66.2 23.2,59 16,66.2 16,86.1 44.9,86.1 44.9,60.6 44.9,66.2 44.9,59 '
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'x' : '31.4',
            'y' : '71.3',
            'fill' : '#FCFBFF',
            'width' : '1.7',
            'height' : '4.1'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'x' : '35.1',
            'y' : '71.3',
            'fill' : '#FCFBFF',
            'width' : '1.7',
            'height' : '4.1'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'x' : '38.8',
            'y' : '71.3',
            'fill' : '#FCFBFF',
            'width' : '1.7',
            'height' : '4.1'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'x' : '29.4',
            'y' : '71.3',
            'fill' : '#FCFBFF',
            'width' : '1.7',
            'height' : '4.1'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'x' : '33.1',
            'y' : '71.3',
            'fill' : '#FCFBFF',
            'width' : '1.7',
            'height' : '4.1'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'x' : '36.8',
            'y' : '71.3',
            'fill' : '#FCFBFF',
            'width' : '1.7',
            'height' : '4.1'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'x' : '40.5',
            'y' : '71.3',
            'fill' : '#FCFBFF',
            'width' : '1.7',
            'height' : '4.1'
        }
    }]
}, {// petroleum
    x : 266,
    x2 : 266,
    p : [{
        'type' : 'path',
        'properties' : {
            'class' : 'sources-active-area',
            'd' : 'M0,85.9c0-24.5,19.8-44.3,44.3-44.3s44.3,19.8,44.3,44.3H0z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M16.6,105.5h1v0.8c0.2-0.3,0.4-0.5,0.7-0.7c0.4-0.2,0.8-0.4,1.3-0.4c0.7,0,1.3,0.3,1.8,0.8c0.5,0.5,0.7,1.3,0.7,2.3c0,1.4-0.4,2.3-1.1,2.9c-0.5,0.4-1,0.6-1.6,0.6c-0.5,0-0.9-0.1-1.2-0.3c-0.2-0.1-0.4-0.3-0.6-0.6v3.2h-1.1V105.5z M20.6,110.4c0.3-0.4,0.5-1,0.5-1.8c0-0.5-0.1-0.9-0.2-1.3c-0.3-0.7-0.8-1-1.5-1c-0.7,0-1.2,0.4-1.5,1.1c-0.1,0.4-0.2,0.9-0.2,1.5c0,0.5,0.1,0.9,0.2,1.2c0.3,0.6,0.8,1,1.5,1C19.9,111,20.3,110.8,20.6,110.4z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M27.3,105.6c0.4,0.2,0.7,0.5,0.9,0.8c0.2,0.3,0.3,0.7,0.4,1.1c0.1,0.3,0.1,0.8,0.1,1.4h-4.6c0,0.6,0.2,1.2,0.4,1.5c0.3,0.4,0.7,0.6,1.3,0.6c0.5,0,1-0.2,1.3-0.5c0.2-0.2,0.3-0.5,0.4-0.7h1c0,0.2-0.1,0.5-0.3,0.8s-0.3,0.5-0.5,0.7c-0.3,0.3-0.7,0.5-1.2,0.6c-0.3,0.1-0.5,0.1-0.9,0.1c-0.8,0-1.4-0.3-2-0.9c-0.5-0.6-0.8-1.4-0.8-2.4c0-1,0.3-1.8,0.8-2.5c0.5-0.6,1.3-0.9,2.1-0.9C26.4,105.3,26.8,105.4,27.3,105.6z M27.6,108.1c0-0.5-0.1-0.8-0.3-1.1c-0.3-0.5-0.8-0.8-1.4-0.8c-0.5,0-0.9,0.2-1.2,0.5s-0.5,0.8-0.5,1.3H27.6z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M30.3,103.7h1.1v1.8h1v0.9h-1v4.1c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0.1,0.4,0.1c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0v0.8c-0.1,0-0.2,0.1-0.4,0.1s-0.3,0-0.4,0c-0.5,0-0.8-0.1-1-0.4s-0.3-0.6-0.3-1v-4.2h-0.8v-0.9h0.8V103.7z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M33.4,105.5h1v1.1c0.1-0.2,0.3-0.5,0.6-0.8s0.7-0.5,1.1-0.5c0,0,0.1,0,0.1,0s0.1,0,0.2,0v1.1c-0.1,0-0.1,0-0.2,0s-0.1,0-0.2,0c-0.5,0-0.9,0.2-1.2,0.5s-0.4,0.7-0.4,1.2v3.6h-1.1V105.5z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M41.9,106.1c0.6,0.5,0.8,1.3,0.8,2.4c0,1-0.2,1.8-0.7,2.5c-0.5,0.7-1.2,1-2.3,1c-0.9,0-1.5-0.3-2-0.9c-0.5-0.6-0.8-1.4-0.8-2.4c0-1.1,0.3-1.9,0.8-2.5c0.5-0.6,1.2-0.9,2.1-0.9C40.7,105.3,41.4,105.5,41.9,106.1z M41.3,110.3c0.3-0.5,0.4-1.1,0.4-1.8c0-0.6-0.1-1.1-0.3-1.4c-0.3-0.6-0.8-0.9-1.5-0.9c-0.6,0-1.1,0.2-1.4,0.7c-0.3,0.5-0.4,1.1-0.4,1.8c0,0.7,0.1,1.2,0.4,1.7c0.3,0.4,0.7,0.7,1.4,0.7C40.6,111.1,41,110.8,41.3,110.3z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M44.1,103.1h1.1v8.6h-1.1V103.1z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M50.6,105.6c0.4,0.2,0.7,0.5,0.9,0.8c0.2,0.3,0.3,0.7,0.4,1.1c0.1,0.3,0.1,0.8,0.1,1.4h-4.6c0,0.6,0.2,1.2,0.4,1.5c0.3,0.4,0.7,0.6,1.3,0.6c0.5,0,1-0.2,1.3-0.5c0.2-0.2,0.3-0.5,0.4-0.7h1c0,0.2-0.1,0.5-0.3,0.8s-0.3,0.5-0.5,0.7c-0.3,0.3-0.7,0.5-1.2,0.6c-0.3,0.1-0.5,0.1-0.9,0.1c-0.8,0-1.4-0.3-2-0.9c-0.5-0.6-0.8-1.4-0.8-2.4c0-1,0.3-1.8,0.8-2.5c0.5-0.6,1.3-0.9,2.1-0.9C49.8,105.3,50.2,105.4,50.6,105.6z M51,108.1c0-0.5-0.1-0.8-0.3-1.1c-0.3-0.5-0.8-0.8-1.4-0.8c-0.5,0-0.9,0.2-1.2,0.5s-0.5,0.8-0.5,1.3H51z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M54.5,105.5v4.2c0,0.3,0,0.6,0.1,0.8c0.2,0.4,0.5,0.6,1,0.6c0.7,0,1.2-0.3,1.5-1c0.1-0.4,0.2-0.8,0.2-1.4v-3.1h1.1v6.3h-1l0-0.9c-0.1,0.2-0.3,0.4-0.5,0.6c-0.4,0.3-0.9,0.5-1.4,0.5c-0.9,0-1.5-0.3-1.8-0.9c-0.2-0.3-0.3-0.7-0.3-1.3v-4.3H54.5z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M60.1,105.5h1v0.9c0.2-0.3,0.5-0.5,0.7-0.7c0.3-0.2,0.7-0.4,1.2-0.4c0.5,0,0.9,0.1,1.2,0.4c0.2,0.1,0.3,0.3,0.5,0.6c0.2-0.3,0.5-0.6,0.8-0.7s0.7-0.2,1.1-0.2c0.8,0,1.4,0.3,1.7,0.9c0.2,0.3,0.2,0.8,0.2,1.3v4.2h-1.1v-4.4c0-0.4-0.1-0.7-0.3-0.9s-0.5-0.2-0.8-0.2c-0.4,0-0.8,0.1-1.1,0.4s-0.4,0.7-0.4,1.4v3.7h-1.1v-4.1c0-0.4-0.1-0.7-0.2-0.9c-0.2-0.3-0.5-0.4-0.9-0.4c-0.4,0-0.8,0.2-1.1,0.5s-0.5,0.9-0.5,1.7v3.3h-1.1V105.5z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M23.7,121.5h1v1.1c0.1-0.2,0.3-0.5,0.6-0.8s0.7-0.5,1.1-0.5c0,0,0.1,0,0.1,0s0.1,0,0.2,0v1.1c-0.1,0-0.1,0-0.2,0s-0.1,0-0.2,0c-0.5,0-0.9,0.2-1.2,0.5s-0.4,0.7-0.4,1.2v3.6h-1.1V121.5z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M31.6,121.6c0.4,0.2,0.7,0.5,0.9,0.8c0.2,0.3,0.3,0.7,0.4,1.1c0.1,0.3,0.1,0.8,0.1,1.4h-4.6c0,0.6,0.2,1.2,0.4,1.5c0.3,0.4,0.7,0.6,1.3,0.6c0.5,0,1-0.2,1.3-0.5c0.2-0.2,0.3-0.5,0.4-0.7h1c0,0.2-0.1,0.5-0.3,0.8s-0.3,0.5-0.5,0.7c-0.3,0.3-0.7,0.5-1.2,0.6c-0.3,0.1-0.5,0.1-0.9,0.1c-0.8,0-1.4-0.3-2-0.9c-0.5-0.6-0.8-1.4-0.8-2.4c0-1,0.3-1.8,0.8-2.5c0.5-0.6,1.3-0.9,2.1-0.9C30.7,121.3,31.2,121.4,31.6,121.6z M32,124.1c0-0.5-0.1-0.8-0.3-1.1c-0.3-0.5-0.8-0.8-1.4-0.8c-0.5,0-0.9,0.2-1.2,0.5s-0.5,0.8-0.5,1.3H32z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M34.9,119.5c0.2-0.4,0.7-0.5,1.4-0.5c0.1,0,0.1,0,0.2,0s0.2,0,0.2,0v1c-0.1,0-0.2,0-0.2,0s-0.1,0-0.1,0c-0.3,0-0.5,0.1-0.6,0.2c-0.1,0.2-0.1,0.6-0.1,1.3h1.1v0.8h-1.1v5.4h-1v-5.4h-0.9v-0.8h0.9v-1C34.7,120.1,34.7,119.7,34.9,119.5z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M37.7,119.1h1.1v1.2h-1.1V119.1z M37.7,121.5h1.1v6.2h-1.1V121.5z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M40.4,121.5h1v0.9c0.3-0.4,0.6-0.6,0.9-0.8s0.7-0.2,1.1-0.2c0.9,0,1.5,0.3,1.8,0.9c0.2,0.3,0.3,0.8,0.3,1.5v4h-1.1v-4c0-0.4-0.1-0.7-0.2-0.9c-0.2-0.4-0.5-0.6-1-0.6c-0.2,0-0.5,0-0.6,0.1c-0.3,0.1-0.5,0.3-0.8,0.5c-0.2,0.2-0.3,0.4-0.3,0.6s-0.1,0.5-0.1,0.9v3.3h-1.1V121.5z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M47.1,119.1h1.1v1.2h-1.1V119.1z M47.1,121.5h1.1v6.2h-1.1V121.5z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M49.7,121.5h1v0.9c0.3-0.4,0.6-0.6,0.9-0.8s0.7-0.2,1.1-0.2c0.9,0,1.5,0.3,1.8,0.9c0.2,0.3,0.3,0.8,0.3,1.5v4h-1.1v-4c0-0.4-0.1-0.7-0.2-0.9c-0.2-0.4-0.5-0.6-1-0.6c-0.2,0-0.5,0-0.6,0.1c-0.3,0.1-0.5,0.3-0.8,0.5c-0.2,0.2-0.3,0.4-0.3,0.6s-0.1,0.5-0.1,0.9v3.3h-1.1V121.5z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M59.9,121.7c0.2,0.1,0.4,0.3,0.6,0.6v-0.8h1v5.7c0,0.8-0.1,1.4-0.3,1.9c-0.4,0.9-1.3,1.3-2.5,1.3c-0.7,0-1.2-0.2-1.7-0.5s-0.7-0.8-0.8-1.4h1.1c0.1,0.3,0.2,0.5,0.3,0.7c0.2,0.2,0.6,0.4,1.1,0.4c0.8,0,1.3-0.3,1.6-0.9c0.1-0.3,0.2-0.9,0.2-1.8c-0.2,0.3-0.5,0.6-0.8,0.7c-0.3,0.2-0.7,0.2-1.2,0.2c-0.7,0-1.3-0.2-1.8-0.7s-0.8-1.3-0.8-2.4c0-1.1,0.3-1.9,0.8-2.5s1.1-0.9,1.9-0.9C59.1,121.3,59.5,121.5,59.9,121.7z M60,122.8c-0.3-0.4-0.7-0.6-1.2-0.6c-0.7,0-1.2,0.3-1.5,1c-0.1,0.4-0.2,0.9-0.2,1.5c0,0.7,0.1,1.2,0.4,1.6c0.3,0.4,0.7,0.6,1.2,0.6c0.8,0,1.3-0.3,1.6-1c0.2-0.4,0.3-0.8,0.3-1.4C60.5,123.8,60.3,123.2,60,122.8z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M16.7,139.9c0.2,0,0.4-0.1,0.5-0.3c0-0.1,0.1-0.2,0.1-0.4c0-0.4-0.1-0.6-0.4-0.8c-0.3-0.2-0.6-0.2-1.1-0.2c-0.5,0-0.9,0.1-1.2,0.4c-0.1,0.2-0.2,0.4-0.3,0.7h-1c0-0.8,0.3-1.3,0.8-1.6c0.5-0.3,1-0.5,1.7-0.5c0.7,0,1.3,0.1,1.8,0.4c0.5,0.3,0.7,0.7,0.7,1.3v3.6c0,0.1,0,0.2,0.1,0.3s0.1,0.1,0.3,0.1c0,0,0.1,0,0.2,0s0.1,0,0.2,0v0.8c-0.2,0-0.3,0.1-0.4,0.1s-0.2,0-0.4,0c-0.4,0-0.6-0.1-0.8-0.4c-0.1-0.1-0.1-0.3-0.2-0.6c-0.2,0.3-0.5,0.5-0.9,0.7s-0.8,0.3-1.3,0.3c-0.6,0-1.1-0.2-1.4-0.5c-0.4-0.4-0.6-0.8-0.6-1.3c0-0.6,0.2-1,0.5-1.4s0.8-0.5,1.4-0.6L16.7,139.9z M14.5,142.8c0.2,0.2,0.5,0.3,0.8,0.3c0.4,0,0.7-0.1,1.1-0.3c0.6-0.3,0.9-0.8,0.9-1.4v-0.8c-0.1,0.1-0.3,0.2-0.5,0.2c-0.2,0.1-0.4,0.1-0.6,0.1l-0.6,0.1c-0.4,0.1-0.7,0.1-0.9,0.2c-0.3,0.2-0.5,0.5-0.5,0.9C14.2,142.4,14.3,142.6,14.5,142.8z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M20,137.5h1v0.9c0.3-0.4,0.6-0.6,0.9-0.8s0.7-0.2,1.1-0.2c0.9,0,1.5,0.3,1.8,0.9c0.2,0.3,0.3,0.8,0.3,1.5v4h-1.1v-4c0-0.4-0.1-0.7-0.2-0.9c-0.2-0.4-0.5-0.6-1-0.6c-0.2,0-0.5,0-0.6,0.1c-0.3,0.1-0.5,0.3-0.8,0.5c-0.2,0.2-0.3,0.4-0.3,0.6s-0.1,0.5-0.1,0.9v3.3H20V137.5z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M30.2,137.7c0.2,0.1,0.4,0.3,0.6,0.6v-3.2h1v8.6h-0.9v-0.9c-0.2,0.4-0.5,0.7-0.9,0.8s-0.7,0.3-1.1,0.3c-0.7,0-1.3-0.3-1.8-0.9s-0.8-1.4-0.8-2.3c0-0.9,0.2-1.7,0.7-2.4s1.1-1,2-1C29.4,137.3,29.8,137.5,30.2,137.7z M27.8,142.4c0.3,0.5,0.7,0.7,1.4,0.7c0.5,0,0.9-0.2,1.2-0.6s0.5-1,0.5-1.8c0-0.8-0.2-1.4-0.5-1.8s-0.7-0.6-1.2-0.6c-0.5,0-1,0.2-1.3,0.6s-0.5,1-0.5,1.8C27.4,141.3,27.5,141.9,27.8,142.4z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M37.4,141.8c0,0.4,0.1,0.6,0.3,0.8c0.3,0.3,0.7,0.5,1.4,0.5c0.4,0,0.8-0.1,1.1-0.3s0.5-0.4,0.5-0.8c0-0.3-0.1-0.5-0.4-0.6c-0.2-0.1-0.5-0.2-0.9-0.3l-0.9-0.2c-0.5-0.1-0.9-0.3-1.2-0.4c-0.5-0.3-0.7-0.7-0.7-1.2c0-0.6,0.2-1.1,0.7-1.4c0.4-0.4,1-0.6,1.7-0.6c1,0,1.6,0.3,2.1,0.8c0.3,0.4,0.4,0.7,0.4,1.1h-1c0-0.2-0.1-0.5-0.3-0.6c-0.2-0.3-0.7-0.4-1.3-0.4c-0.4,0-0.7,0.1-0.9,0.2c-0.2,0.2-0.3,0.4-0.3,0.6c0,0.3,0.1,0.5,0.4,0.7c0.2,0.1,0.4,0.2,0.7,0.3l0.7,0.2c0.8,0.2,1.3,0.4,1.6,0.5c0.4,0.3,0.6,0.7,0.6,1.3c0,0.6-0.2,1-0.6,1.4c-0.4,0.4-1.1,0.6-2,0.6c-0.9,0-1.6-0.2-2-0.6c-0.4-0.4-0.6-0.9-0.6-1.6H37.4z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M42.9,135.7H44v1.8h1v0.9h-1v4.1c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0.1,0.4,0.1c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0v0.8c-0.1,0-0.2,0.1-0.4,0.1s-0.3,0-0.4,0c-0.5,0-0.8-0.1-1-0.4s-0.3-0.6-0.3-1v-4.2h-0.8v-0.9h0.8V135.7z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M50.6,138.1c0.6,0.5,0.8,1.3,0.8,2.4c0,1-0.2,1.8-0.7,2.5c-0.5,0.7-1.2,1-2.3,1c-0.9,0-1.5-0.3-2-0.9c-0.5-0.6-0.8-1.4-0.8-2.4c0-1.1,0.3-1.9,0.8-2.5c0.5-0.6,1.2-0.9,2.1-0.9C49.4,137.3,50.1,137.5,50.6,138.1z M50,142.3c0.3-0.5,0.4-1.1,0.4-1.8c0-0.6-0.1-1.1-0.3-1.4c-0.3-0.6-0.8-0.9-1.5-0.9c-0.6,0-1.1,0.2-1.4,0.7c-0.3,0.5-0.4,1.1-0.4,1.8c0,0.7,0.1,1.2,0.4,1.7c0.3,0.4,0.8,0.7,1.4,0.7C49.2,143.1,49.7,142.8,50,142.3z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M52.8,137.5h1v1.1c0.1-0.2,0.3-0.5,0.6-0.8s0.7-0.5,1.1-0.5c0,0,0.1,0,0.1,0s0.1,0,0.2,0v1.1c-0.1,0-0.1,0-0.2,0s-0.1,0-0.2,0c-0.5,0-0.9,0.2-1.2,0.5s-0.4,0.7-0.4,1.2v3.6h-1.1V137.5z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M60.1,139.9c0.2,0,0.4-0.1,0.5-0.3c0-0.1,0.1-0.2,0.1-0.4c0-0.4-0.1-0.6-0.4-0.8c-0.3-0.2-0.6-0.2-1.1-0.2c-0.5,0-0.9,0.1-1.2,0.4c-0.1,0.2-0.2,0.4-0.3,0.7h-1c0-0.8,0.3-1.3,0.8-1.6c0.5-0.3,1-0.5,1.7-0.5c0.7,0,1.3,0.1,1.8,0.4c0.5,0.3,0.7,0.7,0.7,1.3v3.6c0,0.1,0,0.2,0.1,0.3s0.1,0.1,0.3,0.1c0,0,0.1,0,0.2,0s0.1,0,0.2,0v0.8c-0.2,0-0.3,0.1-0.4,0.1s-0.2,0-0.4,0c-0.4,0-0.6-0.1-0.8-0.4c-0.1-0.1-0.1-0.3-0.2-0.6c-0.2,0.3-0.5,0.5-0.9,0.7s-0.8,0.3-1.3,0.3c-0.6,0-1.1-0.2-1.4-0.5c-0.4-0.4-0.6-0.8-0.6-1.3c0-0.6,0.2-1,0.5-1.4s0.8-0.5,1.4-0.6L60.1,139.9z M57.9,142.8c0.2,0.2,0.5,0.3,0.8,0.3c0.4,0,0.7-0.1,1.1-0.3c0.6-0.3,0.9-0.8,0.9-1.4v-0.8c-0.1,0.1-0.3,0.2-0.5,0.2c-0.2,0.1-0.4,0.1-0.6,0.1l-0.6,0.1c-0.4,0.1-0.7,0.1-0.9,0.2c-0.3,0.2-0.5,0.5-0.5,0.9C57.5,142.4,57.7,142.6,57.9,142.8z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M66.9,137.7c0.2,0.1,0.4,0.3,0.6,0.6v-0.8h1v5.7c0,0.8-0.1,1.4-0.4,1.9c-0.4,0.9-1.3,1.3-2.5,1.3c-0.7,0-1.2-0.2-1.7-0.5s-0.7-0.8-0.8-1.4h1.1c0,0.3,0.2,0.5,0.3,0.7c0.2,0.2,0.6,0.4,1.1,0.4c0.8,0,1.3-0.3,1.6-0.9c0.1-0.3,0.2-0.9,0.2-1.8c-0.2,0.3-0.5,0.6-0.8,0.7c-0.3,0.2-0.7,0.2-1.2,0.2c-0.7,0-1.3-0.2-1.8-0.7s-0.8-1.3-0.8-2.4c0-1.1,0.3-1.9,0.8-2.5s1.1-0.9,1.9-0.9C66.1,137.3,66.5,137.5,66.9,137.7z M67,138.8c-0.3-0.4-0.7-0.6-1.2-0.6c-0.7,0-1.2,0.3-1.5,1c-0.1,0.4-0.2,0.9-0.2,1.5c0,0.7,0.1,1.2,0.4,1.6s0.7,0.6,1.2,0.6c0.8,0,1.3-0.3,1.6-1c0.2-0.4,0.3-0.8,0.3-1.4C67.5,139.8,67.3,139.2,67,138.8z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M74,137.6c0.4,0.2,0.7,0.5,0.9,0.8c0.2,0.3,0.3,0.7,0.4,1.1c0.1,0.3,0.1,0.8,0.1,1.4h-4.6c0,0.6,0.2,1.2,0.4,1.5c0.3,0.4,0.7,0.6,1.3,0.6c0.5,0,1-0.2,1.3-0.5c0.2-0.2,0.3-0.5,0.4-0.7h1c0,0.2-0.1,0.5-0.3,0.8s-0.3,0.5-0.5,0.7c-0.3,0.3-0.7,0.5-1.2,0.6c-0.3,0.1-0.5,0.1-0.9,0.1c-0.8,0-1.4-0.3-2-0.9c-0.5-0.6-0.8-1.4-0.8-2.4c0-1,0.3-1.8,0.8-2.5c0.5-0.6,1.3-0.9,2.1-0.9C73.1,137.3,73.5,137.4,74,137.6z M74.3,140.1c0-0.5-0.1-0.8-0.3-1.1c-0.3-0.5-0.8-0.8-1.4-0.8c-0.5,0-0.9,0.2-1.2,0.5s-0.5,0.8-0.5,1.3H74.3z'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_6070_'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_6094_'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_6111_'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_6115_',
            'x' : '25.2',
            'y' : '58.6',
            'fill' : '#004A7A',
            'width' : '9.8',
            'height' : '7.4'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_6114_',
            'x' : '34.8',
            'y' : '58.6',
            'fill' : '#00B9ED',
            'width' : '6.6',
            'height' : '7.4'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_6113_',
            'x' : '25.2',
            'y' : '58.6',
            'fill' : '#004A7A',
            'width' : '16.1',
            'height' : '1'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_6112_',
            'x' : '24.6',
            'y' : '57.5',
            'fill' : '#00B9ED',
            'width' : '17.7',
            'height' : '1.1'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_6105_'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_6110_',
            'x' : '25.2',
            'y' : '67',
            'fill' : '#004A7A',
            'width' : '9.8',
            'height' : '7.4'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_6108_',
            'x' : '34.8',
            'y' : '67',
            'fill' : '#00B9ED',
            'width' : '6.6',
            'height' : '7.4'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_6107_',
            'x' : '25.2',
            'y' : '67',
            'fill' : '#004A7A',
            'width' : '16.1',
            'height' : '1'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_6106_',
            'x' : '24.6',
            'y' : '65.9',
            'fill' : '#00B9ED',
            'width' : '17.7',
            'height' : '1.1'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_6095_'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_6101_',
            'x' : '25.2',
            'y' : '75.4',
            'fill' : '#004A7A',
            'width' : '9.8',
            'height' : '7.4'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_6100_',
            'x' : '34.8',
            'y' : '75.4',
            'fill' : '#00B9ED',
            'width' : '6.6',
            'height' : '7.4'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_6099_',
            'x' : '25.2',
            'y' : '75.4',
            'fill' : '#004A7A',
            'width' : '16.1',
            'height' : '1'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_6097_',
            'x' : '24.6',
            'y' : '74.3',
            'fill' : '#00B9ED',
            'width' : '17.7',
            'height' : '1.1'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_6096_',
            'x' : '24.6',
            'y' : '82.8',
            'fill' : '#00B9ED',
            'width' : '17.7',
            'height' : '1.1'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_6075_'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_6087_'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_6091_',
            'x' : '47.6',
            'y' : '58.6',
            'fill' : '#004A7A',
            'width' : '9.8',
            'height' : '7.4'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_6090_',
            'x' : '57.1',
            'y' : '58.6',
            'fill' : '#00B9ED',
            'width' : '6.6',
            'height' : '7.4'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_6089_',
            'x' : '47.6',
            'y' : '58.6',
            'fill' : '#004A7A',
            'width' : '16.1',
            'height' : '1'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_6088_',
            'x' : '47',
            'y' : '57.5',
            'fill' : '#00B9ED',
            'width' : '17.7',
            'height' : '1.1'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_6082_'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_6086_',
            'x' : '47.6',
            'y' : '67',
            'fill' : '#004A7A',
            'width' : '9.8',
            'height' : '7.4'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_6085_',
            'x' : '57.1',
            'y' : '67',
            'fill' : '#00B9ED',
            'width' : '6.6',
            'height' : '7.4'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_6084_',
            'x' : '47.6',
            'y' : '67',
            'fill' : '#004A7A',
            'width' : '16.1',
            'height' : '1'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_6083_',
            'x' : '47',
            'y' : '65.9',
            'fill' : '#00B9ED',
            'width' : '17.7',
            'height' : '1.1'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_6076_'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_6081_',
            'x' : '47.6',
            'y' : '75.4',
            'fill' : '#004A7A',
            'width' : '9.8',
            'height' : '7.4'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_6080_',
            'x' : '57.1',
            'y' : '75.4',
            'fill' : '#00B9ED',
            'width' : '6.6',
            'height' : '7.4'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_6079_',
            'x' : '47.6',
            'y' : '75.4',
            'fill' : '#004A7A',
            'width' : '16.1',
            'height' : '1'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_6078_',
            'x' : '47',
            'y' : '74.3',
            'fill' : '#00B9ED',
            'width' : '17.7',
            'height' : '1.1'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_6077_',
            'x' : '47',
            'y' : '82.8',
            'fill' : '#00B9ED',
            'width' : '17.7',
            'height' : '1.1'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_6072_',
            'x' : '28.2',
            'y' : '69',
            'fill' : '#FDFCFF',
            'width' : '9.5',
            'height' : '3.5'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_6071_',
            'x' : '60.4',
            'y' : '69',
            'fill' : '#FDFCFF',
            'width' : '3.2',
            'height' : '3.5'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_878_'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_1386_'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_2525_',
            'x' : '36.9',
            'y' : '31.9',
            'fill' : '#004A7A',
            'width' : '9.8',
            'height' : '7.4'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_1737_',
            'x' : '46.5',
            'y' : '31.9',
            'fill' : '#00B9ED',
            'width' : '6.6',
            'height' : '7.4'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_1736_',
            'x' : '36.9',
            'y' : '31.9',
            'fill' : '#004A7A',
            'width' : '16.1',
            'height' : '1'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_1702_',
            'x' : '36.3',
            'y' : '30.9',
            'fill' : '#00B9ED',
            'width' : '17.7',
            'height' : '1.1'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_1132_'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_1385_',
            'x' : '36.9',
            'y' : '40.3',
            'fill' : '#004A7A',
            'width' : '9.8',
            'height' : '7.4'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_1384_',
            'x' : '46.5',
            'y' : '40.3',
            'fill' : '#00B9ED',
            'width' : '6.6',
            'height' : '7.4'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_1362_',
            'x' : '36.9',
            'y' : '40.3',
            'fill' : '#004A7A',
            'width' : '16.1',
            'height' : '1'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_1134_',
            'x' : '36.3',
            'y' : '39.3',
            'fill' : '#00B9ED',
            'width' : '17.7',
            'height' : '1.1'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_879_'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_1083_',
            'x' : '36.9',
            'y' : '48.7',
            'fill' : '#004A7A',
            'width' : '9.8',
            'height' : '7.4'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_1048_',
            'x' : '46.5',
            'y' : '48.7',
            'fill' : '#00B9ED',
            'width' : '6.6',
            'height' : '7.4'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_1037_',
            'x' : '36.9',
            'y' : '48.7',
            'fill' : '#004A7A',
            'width' : '16.1',
            'height' : '1'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_1016_',
            'x' : '36.3',
            'y' : '47.7',
            'fill' : '#00B9ED',
            'width' : '17.7',
            'height' : '1.1'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_891_',
            'x' : '36.3',
            'y' : '56.1',
            'fill' : '#00B9ED',
            'width' : '17.7',
            'height' : '1.1'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_708_',
            'x' : '49.7',
            'y' : '42.4',
            'fill' : '#FDFCFF',
            'width' : '3.2',
            'height' : '3.5'
        }
    }]
}, {// road transport
    x : 356,
    x2 : 356,
    p : [{
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M39.4,104.7h1v1.1c0.1-0.2,0.3-0.5,0.6-0.8s0.7-0.5,1.1-0.5c0,0,0.1,0,0.1,0s0.1,0,0.2,0v1.1c-0.1,0-0.1,0-0.2,0s-0.1,0-0.2,0c-0.5,0-0.9,0.2-1.2,0.5s-0.4,0.7-0.4,1.2v3.6h-1.1V104.7z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M47.9,105.3c0.6,0.5,0.8,1.3,0.8,2.4c0,1-0.2,1.8-0.7,2.5c-0.5,0.7-1.2,1-2.3,1c-0.9,0-1.5-0.3-2-0.9c-0.5-0.6-0.8-1.4-0.8-2.4c0-1.1,0.3-1.9,0.8-2.5c0.5-0.6,1.2-0.9,2.1-0.9C46.7,104.5,47.4,104.8,47.9,105.3z M47.3,109.5c0.3-0.5,0.4-1.1,0.4-1.8c0-0.6-0.1-1.1-0.3-1.4c-0.3-0.6-0.8-0.9-1.5-0.9c-0.6,0-1.1,0.2-1.4,0.7c-0.3,0.5-0.4,1.1-0.4,1.8c0,0.7,0.1,1.2,0.4,1.7c0.3,0.4,0.7,0.7,1.4,0.7C46.6,110.3,47,110,47.3,109.5z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M53.4,107.2c0.2,0,0.4-0.1,0.5-0.3c0-0.1,0.1-0.2,0.1-0.4c0-0.4-0.1-0.6-0.4-0.8c-0.3-0.2-0.6-0.2-1.1-0.2c-0.5,0-0.9,0.1-1.2,0.4c-0.1,0.2-0.2,0.4-0.3,0.7h-1c0-0.8,0.3-1.3,0.8-1.6s1-0.5,1.7-0.5c0.7,0,1.3,0.1,1.8,0.4c0.5,0.3,0.7,0.7,0.7,1.3v3.6c0,0.1,0,0.2,0.1,0.3s0.1,0.1,0.3,0.1c0,0,0.1,0,0.2,0s0.1,0,0.2,0v0.8c-0.2,0-0.3,0.1-0.4,0.1s-0.2,0-0.4,0c-0.4,0-0.6-0.1-0.8-0.4c-0.1-0.1-0.1-0.3-0.2-0.6c-0.2,0.3-0.5,0.5-0.9,0.7s-0.8,0.3-1.3,0.3c-0.6,0-1.1-0.2-1.4-0.5c-0.4-0.4-0.6-0.8-0.6-1.3c0-0.6,0.2-1,0.5-1.4c0.4-0.3,0.8-0.5,1.4-0.6L53.4,107.2z M51.2,110c0.2,0.2,0.5,0.3,0.8,0.3c0.4,0,0.7-0.1,1.1-0.3c0.6-0.3,0.9-0.8,0.9-1.4v-0.8c-0.1,0.1-0.3,0.2-0.5,0.2s-0.4,0.1-0.6,0.1l-0.6,0.1c-0.4,0.1-0.7,0.1-0.9,0.2c-0.3,0.2-0.5,0.5-0.5,0.9C50.9,109.6,51,109.8,51.2,110z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M60.2,104.9c0.2,0.1,0.4,0.3,0.6,0.6v-3.2h1v8.6h-0.9v-0.9c-0.2,0.4-0.5,0.7-0.9,0.8c-0.3,0.2-0.7,0.3-1.1,0.3c-0.7,0-1.3-0.3-1.8-0.9s-0.8-1.4-0.8-2.3c0-0.9,0.2-1.7,0.7-2.4s1.1-1,2-1C59.5,104.6,59.9,104.7,60.2,104.9z M57.8,109.6c0.3,0.5,0.7,0.7,1.4,0.7c0.5,0,0.9-0.2,1.2-0.6c0.3-0.4,0.5-1,0.5-1.8c0-0.8-0.2-1.4-0.5-1.8c-0.3-0.4-0.7-0.6-1.2-0.6c-0.5,0-1,0.2-1.3,0.6c-0.3,0.4-0.5,1-0.5,1.8C57.4,108.6,57.5,109.1,57.8,109.6z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M29.6,118.9h1.1v1.8h1v0.9h-1v4.1c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0.1,0.4,0.1c0.1,0,0.1,0,0.2,0s0.1,0,0.2,0v0.8c-0.1,0-0.2,0.1-0.4,0.1s-0.3,0-0.4,0c-0.5,0-0.8-0.1-1-0.4s-0.3-0.6-0.3-1v-4.2h-0.8v-0.9h0.8V118.9z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M32.8,120.7h1v1.1c0.1-0.2,0.3-0.5,0.6-0.8s0.7-0.5,1.1-0.5c0,0,0.1,0,0.1,0s0.1,0,0.2,0v1.1c-0.1,0-0.1,0-0.2,0s-0.1,0-0.2,0c-0.5,0-0.9,0.2-1.2,0.5s-0.4,0.7-0.4,1.2v3.6h-1.1V120.7z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M40.1,123.2c0.2,0,0.4-0.1,0.5-0.3c0-0.1,0.1-0.2,0.1-0.4c0-0.4-0.1-0.6-0.4-0.8c-0.3-0.2-0.6-0.2-1.1-0.2c-0.5,0-0.9,0.1-1.2,0.4c-0.1,0.2-0.2,0.4-0.3,0.7h-1c0-0.8,0.3-1.3,0.8-1.6s1-0.5,1.7-0.5c0.7,0,1.3,0.1,1.8,0.4c0.5,0.3,0.7,0.7,0.7,1.3v3.6c0,0.1,0,0.2,0.1,0.3s0.1,0.1,0.3,0.1c0,0,0.1,0,0.2,0s0.1,0,0.2,0v0.8c-0.2,0-0.3,0.1-0.4,0.1s-0.2,0-0.4,0c-0.4,0-0.6-0.1-0.8-0.4c-0.1-0.1-0.1-0.3-0.2-0.6c-0.2,0.3-0.5,0.5-0.9,0.7s-0.8,0.3-1.3,0.3c-0.6,0-1.1-0.2-1.4-0.5c-0.4-0.4-0.6-0.8-0.6-1.3c0-0.6,0.2-1,0.5-1.4c0.4-0.3,0.8-0.5,1.4-0.6L40.1,123.2z M37.9,126c0.2,0.2,0.5,0.3,0.8,0.3c0.4,0,0.7-0.1,1.1-0.3c0.6-0.3,0.9-0.8,0.9-1.4v-0.8c-0.1,0.1-0.3,0.2-0.5,0.2s-0.4,0.1-0.6,0.1l-0.6,0.1c-0.4,0.1-0.7,0.1-0.9,0.2c-0.3,0.2-0.5,0.5-0.5,0.9C37.5,125.6,37.6,125.8,37.9,126z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M43.4,120.7h1v0.9c0.3-0.4,0.6-0.6,0.9-0.8s0.7-0.2,1.1-0.2c0.9,0,1.5,0.3,1.8,0.9c0.2,0.3,0.3,0.8,0.3,1.5v4h-1.1v-4c0-0.4-0.1-0.7-0.2-0.9c-0.2-0.4-0.5-0.6-1-0.6c-0.2,0-0.5,0-0.6,0.1c-0.3,0.1-0.5,0.3-0.8,0.5c-0.2,0.2-0.3,0.4-0.3,0.6s-0.1,0.5-0.1,0.9v3.3h-1.1V120.7z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M50.7,125c0,0.4,0.1,0.6,0.3,0.8c0.3,0.3,0.7,0.5,1.4,0.5c0.4,0,0.7-0.1,1.1-0.3s0.5-0.4,0.5-0.8c0-0.3-0.1-0.5-0.4-0.6c-0.2-0.1-0.5-0.2-0.9-0.3l-0.9-0.2c-0.5-0.1-0.9-0.3-1.2-0.4c-0.5-0.3-0.7-0.7-0.7-1.2c0-0.6,0.2-1.1,0.7-1.4c0.4-0.4,1-0.6,1.7-0.6c1,0,1.6,0.3,2.1,0.8c0.3,0.4,0.4,0.7,0.4,1.1h-1c0-0.2-0.1-0.5-0.3-0.6c-0.2-0.3-0.7-0.4-1.3-0.4c-0.4,0-0.7,0.1-0.9,0.2c-0.2,0.2-0.3,0.4-0.3,0.6c0,0.3,0.1,0.5,0.4,0.7c0.2,0.1,0.4,0.2,0.7,0.3l0.7,0.2c0.8,0.2,1.3,0.4,1.6,0.5c0.4,0.3,0.6,0.7,0.6,1.3c0,0.6-0.2,1-0.6,1.4c-0.4,0.4-1.1,0.6-2,0.6c-0.9,0-1.6-0.2-2-0.6s-0.6-0.9-0.6-1.6H50.7z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M56,120.7h1v0.8c0.2-0.3,0.4-0.5,0.7-0.7c0.4-0.2,0.8-0.4,1.3-0.4c0.7,0,1.3,0.3,1.8,0.8c0.5,0.5,0.7,1.3,0.7,2.3c0,1.4-0.4,2.3-1.1,2.9c-0.5,0.4-1,0.6-1.6,0.6c-0.5,0-0.9-0.1-1.2-0.3c-0.2-0.1-0.4-0.3-0.6-0.6v3.2H56V120.7z M60,125.6c0.3-0.4,0.5-1,0.5-1.8c0-0.5-0.1-0.9-0.2-1.3c-0.3-0.7-0.8-1-1.5-1c-0.7,0-1.2,0.4-1.5,1.1c-0.1,0.4-0.2,0.9-0.2,1.5c0,0.5,0.1,0.9,0.2,1.2c0.3,0.6,0.8,1,1.5,1C59.2,126.2,59.6,126,60,125.6z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M67.3,121.3c0.6,0.5,0.8,1.3,0.8,2.4c0,1-0.2,1.8-0.7,2.5c-0.5,0.7-1.2,1-2.3,1c-0.9,0-1.5-0.3-2-0.9c-0.5-0.6-0.8-1.4-0.8-2.4c0-1.1,0.3-1.9,0.8-2.5c0.5-0.6,1.2-0.9,2.1-0.9C66.1,120.5,66.7,120.8,67.3,121.3z M66.6,125.5c0.3-0.5,0.4-1.1,0.4-1.8c0-0.6-0.1-1.1-0.3-1.4c-0.3-0.6-0.8-0.9-1.5-0.9c-0.6,0-1.1,0.2-1.4,0.7c-0.3,0.5-0.4,1.1-0.4,1.8c0,0.7,0.1,1.2,0.4,1.7c0.3,0.4,0.7,0.7,1.4,0.7C65.9,126.3,66.4,126,66.6,125.5z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M69.5,120.7h1v1.1c0.1-0.2,0.3-0.5,0.6-0.8s0.7-0.5,1.1-0.5c0,0,0.1,0,0.1,0s0.1,0,0.2,0v1.1c-0.1,0-0.1,0-0.2,0s-0.1,0-0.2,0c-0.5,0-0.9,0.2-1.2,0.5s-0.4,0.7-0.4,1.2v3.6h-1.1V120.7z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M73.6,118.9h1.1v1.8h1v0.9h-1v4.1c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0.1,0.4,0.1c0.1,0,0.1,0,0.2,0s0.1,0,0.2,0v0.8c-0.1,0-0.2,0.1-0.4,0.1s-0.3,0-0.4,0c-0.5,0-0.8-0.1-1-0.4s-0.3-0.6-0.3-1v-4.2h-0.8v-0.9h0.8V118.9z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'class' : 'sources-active-area',
            'd' : 'M6.8,85.9c0-24.5,19.8-44.3,44.3-44.3s44.3,19.8,44.3,44.3H6.8z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#00B9ED',
            'd' : 'M90.8,70.1H99c2.1,0,4.1,1.1,5.2,3l2.3,3.9h6.8l1.5,6H88.2l2.5-8.5C91.5,71.9,88.2,70.1,90.8,70.1'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M82.8,70.1h7.7c2.1,0,4.1,1.1,5.2,3l2.3,3.9h6.8l1.5,6H80.4l1.5-12.1C82,70.4,82.4,70.1,82.8,70.1'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M68.7,77.2c-1.6,0-2.9,1.8-2.9,4.1c0,2.3,1.3,4.1,2.9,4.1h1.4c1.6,0,2.9-1.8,2.9-4.1c0-2.3-1.3-4.1-2.9-4.1H68.7z'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'x' : '49.3',
            'y' : '50.9',
            'fill' : '#00B9ED',
            'width' : '16.6',
            'height' : '25.4'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'y' : '50.9',
            'fill' : '#004A7A',
            'width' : '49.3',
            'height' : '25.4'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'x' : '24.5',
            'y' : '77.4',
            'fill' : '#004A7A',
            'width' : '9.8',
            'height' : '5.8'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'x' : '34.3',
            'y' : '77.4',
            'fill' : '#00B9ED',
            'width' : '3.9',
            'height' : '5.8'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'x' : '77',
            'y' : '64.7',
            'fill' : '#00B9ED',
            'width' : '2.4',
            'height' : '7.2'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#00B9ED',
            'd' : 'M76.5,59.6H60.4v-6h11.5c2.6,0,4.6,2.1,4.6,4.6V59.6z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M64,59.6h-11v-6h6.3c2.6,0,4.6,2.1,4.6,4.6V59.6z'
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'fill' : '#FDFCFF',
            'points' : '78.1,70.2 65.7,70.2 64.1,59.6 76.5,59.6 '
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'x' : '65.7',
            'y' : '70.2',
            'fill' : '#00B9ED',
            'width' : '12.4',
            'height' : '10.6'
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'fill' : '#004A7A',
            'points' : '65.7,70.2 65.7,80.8 53.1,80.8 53.1,70.2 53.1,59.6 64,59.6 '
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'fill' : '#FDFCFF',
            'points' : '64.4,70.2 62.9,59.6 56.8,59.6 56.8,70.3 '
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'x' : '60.8',
            'y' : '64.7',
            'fill' : '#00B9ED',
            'width' : '2.4',
            'height' : '7.2'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'x' : '68.5',
            'y' : '72.6',
            'fill' : '#004A7A',
            'width' : '7.3',
            'height' : '8'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'x' : '64.2',
            'y' : '80.2',
            'fill' : '#00B9ED',
            'width' : '14.9',
            'height' : '3.1'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M4.5,77.2c-1.6,0-2.9,1.8-2.9,4.1c0,2.3,1.3,4.1,2.9,4.1h1.4c1.6,0,2.9-1.8,2.9-4.1c0-2.3-1.3-4.1-2.9-4.1H4.5z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M10.9,77.2C9.3,77.2,8,79,8,81.3c0,2.3,1.3,4.1,2.9,4.1h1.4c1.6,0,2.9-1.8,2.9-4.1c0-2.3-1.3-4.1-2.9-4.1H10.9z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M17.7,77.2c-1.6,0-2.9,1.8-2.9,4.1c0,2.3,1.3,4.1,2.9,4.1h1.4c1.6,0,2.9-1.8,2.9-4.1c0-2.3-1.3-4.1-2.9-4.1H17.7z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#00B9ED',
            'd' : 'M64.3,80.8c0-2.9-1.6-5.2-3.7-5.2h-1.8c-2,0-3.7,2.3-3.7,5.2'
        }
    }, {
        'type' : 'polyline',
        'properties' : {
            'fill' : '#004A7A',
            'points' : '63.7,83.3 63.7,80.1 66.3,80.1 66.3,83.3 '
        }
    }, {
        'type' : 'polyline',
        'properties' : {
            'fill' : '#00B9ED',
            'points' : '69.8,82.4 69.8,81 74.8,81 74.8,82.4 '
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M43,77.2c-1.6,0-2.9,1.8-2.9,4.1c0,2.3,1.3,4.1,2.9,4.1h1.4c1.6,0,2.9-1.8,2.9-4.1c0-2.3-1.3-4.1-2.9-4.1H43z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M49.8,77.2c-1.6,0-2.9,1.8-2.9,4.1c0,2.3,1.3,4.1,2.9,4.1h1.4c1.6,0,2.9-1.8,2.9-4.1c0-2.3-1.3-4.1-2.9-4.1H49.8z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M59,77.2c-1.6,0-2.9,1.8-2.9,4.1c0,2.3,1.3,4.1,2.9,4.1h1.4c1.6,0,2.9-1.8,2.9-4.1c0-2.3-1.3-4.1-2.9-4.1H59z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#FDFCFF',
            'd' : 'M5.5,81.2c0,1.1-0.5,2-1.2,2S3,82.3,3,81.2s0.5-2,1.2-2S5.5,80.2,5.5,81.2'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#FDFCFF',
            'd' : 'M12,81.2c0,1.1-0.5,2-1.2,2s-1.2-0.9-1.2-2s0.5-2,1.2-2S12,80.2,12,81.2'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#FDFCFF',
            'd' : 'M18.8,81.2c0,1.1-0.5,2-1.2,2c-0.7,0-1.2-0.9-1.2-2s0.5-2,1.2-2C18.3,79.3,18.8,80.2,18.8,81.2'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#FDFCFF',
            'd' : 'M44.1,81.2c0,1.1-0.5,2-1.2,2s-1.2-0.9-1.2-2s0.5-2,1.2-2S44.1,80.2,44.1,81.2'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#FDFCFF',
            'd' : 'M50.9,81.2c0,1.1-0.5,2-1.2,2c-0.7,0-1.2-0.9-1.2-2s0.5-2,1.2-2C50.4,79.3,50.9,80.2,50.9,81.2'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#FDFCFF',
            'd' : 'M60.1,81.2c0,1.1-0.5,2-1.2,2c-0.7,0-1.2-0.9-1.2-2s0.5-2,1.2-2C59.5,79.3,60.1,80.2,60.1,81.2'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M99.3,79.5c-1.1,0-2,1.3-2,2.8c0,1.6,0.9,2.8,2,2.8h1c1.1,0,2-1.3,2-2.8c0-1.6-0.9-2.8-2-2.8H99.3z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#FDFCFF',
            'd' : 'M100.1,82.3c0,0.8-0.4,1.4-0.8,1.4c-0.5,0-0.8-0.6-0.8-1.4s0.4-1.4,0.8-1.4C99.7,81,100.1,81.6,100.1,82.3'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M85.4,79.5c-1.1,0-2,1.3-2,2.8c0,1.6,0.9,2.8,2,2.8h1c1.1,0,2-1.3,2-2.8c0-1.6-0.9-2.8-2-2.8H85.4z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#FDFCFF',
            'd' : 'M86.2,82.3c0,0.8-0.4,1.4-0.8,1.4c-0.5,0-0.8-0.6-0.8-1.4s0.4-1.4,0.8-1.4C85.8,81,86.2,81.6,86.2,82.3'
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'fill' : '#003867',
            'points' : '105.1,81.9 106.7,81.9 107.1,83.8 104.3,83.8 104.3,81.9 '
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'fill' : '#00B9ED',
            'points' : '115.6,83.8 107.1,83.8 106.7,81.9 115.3,81.9 '
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#003867',
            'd' : 'M107.8,81.8l-0.7-3.5h5l1,3.4C113.2,81.7,107.7,81.8,107.8,81.8'
        }
    }]
}, {// non-road
    x : 490,
    x2 : 510,
    p : [{
        'type' : 'path',
        'properties' : {
            'class' : 'sources-active-area',
            'd' : 'M21.3,87.2c0-24.5,19.8-44.3,44.3-44.3c24.5,0,44.3,19.8,44.3,44.3H21.3z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M40.4,105.5h1v0.9c0.3-0.4,0.6-0.6,0.9-0.8s0.7-0.2,1.1-0.2c0.9,0,1.5,0.3,1.8,0.9c0.2,0.3,0.3,0.8,0.3,1.5v4h-1.1v-4c0-0.4-0.1-0.7-0.2-0.9c-0.2-0.4-0.5-0.6-1-0.6c-0.2,0-0.5,0-0.6,0.1c-0.3,0.1-0.5,0.3-0.8,0.5c-0.2,0.2-0.3,0.4-0.3,0.6s-0.1,0.5-0.1,0.9v3.3h-1.1V105.5z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M51.6,106.1c0.6,0.5,0.8,1.3,0.8,2.4c0,1-0.2,1.8-0.7,2.5c-0.5,0.7-1.2,1-2.3,1c-0.9,0-1.5-0.3-2-0.9c-0.5-0.6-0.8-1.4-0.8-2.4c0-1.1,0.3-1.9,0.8-2.5c0.5-0.6,1.2-0.9,2.1-0.9C50.4,105.3,51,105.5,51.6,106.1z M50.9,110.3c0.3-0.5,0.4-1.1,0.4-1.8c0-0.6-0.1-1.1-0.3-1.4c-0.3-0.6-0.8-0.9-1.5-0.9c-0.6,0-1.1,0.2-1.4,0.7c-0.3,0.5-0.4,1.1-0.4,1.8c0,0.7,0.1,1.2,0.4,1.7c0.3,0.4,0.7,0.7,1.4,0.7C50.2,111.1,50.7,110.8,50.9,110.3z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M53.7,105.5h1v0.9c0.3-0.4,0.6-0.6,0.9-0.8s0.7-0.2,1.1-0.2c0.9,0,1.5,0.3,1.8,0.9c0.2,0.3,0.3,0.8,0.3,1.5v4h-1.1v-4c0-0.4-0.1-0.7-0.2-0.9c-0.2-0.4-0.5-0.6-1-0.6c-0.2,0-0.5,0-0.6,0.1c-0.3,0.1-0.5,0.3-0.8,0.5c-0.2,0.2-0.3,0.4-0.3,0.6s-0.1,0.5-0.1,0.9v3.3h-1.1V105.5z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M60.1,107.9h2.9v1.1h-2.9V107.9z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M64.4,105.5h1v1.1c0.1-0.2,0.3-0.5,0.6-0.8s0.7-0.5,1.1-0.5c0,0,0.1,0,0.1,0s0.1,0,0.2,0v1.1c-0.1,0-0.1,0-0.2,0s-0.1,0-0.2,0c-0.5,0-0.9,0.2-1.2,0.5s-0.4,0.7-0.4,1.2v3.6h-1.1V105.5z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M72.9,106.1c0.6,0.5,0.8,1.3,0.8,2.4c0,1-0.2,1.8-0.7,2.5c-0.5,0.7-1.2,1-2.3,1c-0.9,0-1.5-0.3-2-0.9c-0.5-0.6-0.8-1.4-0.8-2.4c0-1.1,0.3-1.9,0.8-2.5c0.5-0.6,1.2-0.9,2.1-0.9C71.7,105.3,72.4,105.5,72.9,106.1z M72.3,110.3c0.3-0.5,0.4-1.1,0.4-1.8c0-0.6-0.1-1.1-0.3-1.4c-0.3-0.6-0.8-0.9-1.5-0.9c-0.6,0-1.1,0.2-1.4,0.7c-0.3,0.5-0.4,1.1-0.4,1.8c0,0.7,0.1,1.2,0.4,1.7c0.3,0.4,0.7,0.7,1.4,0.7C71.6,111.1,72,110.8,72.3,110.3z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M78.4,107.9c0.2,0,0.4-0.1,0.5-0.3c0-0.1,0.1-0.2,0.1-0.4c0-0.4-0.1-0.6-0.4-0.8c-0.3-0.2-0.6-0.2-1.1-0.2c-0.6,0-0.9,0.1-1.2,0.4c-0.1,0.2-0.2,0.4-0.3,0.7h-1c0-0.8,0.3-1.3,0.8-1.6c0.5-0.3,1-0.5,1.7-0.5c0.7,0,1.3,0.1,1.8,0.4c0.5,0.3,0.7,0.7,0.7,1.3v3.6c0,0.1,0,0.2,0.1,0.3s0.1,0.1,0.3,0.1c0,0,0.1,0,0.2,0s0.1,0,0.2,0v0.8c-0.2,0-0.3,0.1-0.4,0.1s-0.2,0-0.4,0c-0.4,0-0.6-0.1-0.8-0.4c-0.1-0.1-0.1-0.3-0.2-0.6c-0.2,0.3-0.5,0.5-0.9,0.7s-0.8,0.3-1.3,0.3c-0.6,0-1.1-0.2-1.4-0.5c-0.4-0.4-0.6-0.8-0.6-1.3c0-0.6,0.2-1,0.5-1.4s0.8-0.5,1.4-0.6L78.4,107.9z M76.2,110.8c0.2,0.2,0.5,0.3,0.8,0.3c0.4,0,0.7-0.1,1.1-0.3c0.6-0.3,0.9-0.8,0.9-1.4v-0.8c-0.1,0.1-0.3,0.2-0.5,0.2c-0.2,0.1-0.4,0.1-0.6,0.1l-0.6,0.1c-0.4,0.1-0.7,0.1-0.9,0.2c-0.3,0.2-0.5,0.5-0.5,0.9C75.9,110.4,76,110.6,76.2,110.8z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M85.2,105.7c0.2,0.1,0.4,0.3,0.6,0.6v-3.2h1v8.6h-0.9v-0.9c-0.2,0.4-0.5,0.7-0.9,0.8c-0.3,0.2-0.7,0.3-1.2,0.3c-0.7,0-1.3-0.3-1.8-0.9s-0.8-1.4-0.8-2.3c0-0.9,0.2-1.7,0.7-2.4c0.5-0.7,1.1-1,2-1C84.5,105.3,84.9,105.5,85.2,105.7z M82.8,110.4c0.3,0.5,0.7,0.7,1.4,0.7c0.5,0,0.9-0.2,1.2-0.6s0.5-1,0.5-1.8c0-0.8-0.2-1.4-0.5-1.8s-0.7-0.6-1.2-0.6c-0.5,0-1,0.2-1.3,0.6c-0.3,0.4-0.5,1-0.5,1.8C82.4,109.3,82.5,109.9,82.8,110.4z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M46.7,121.5h1v0.9c0.2-0.3,0.5-0.5,0.7-0.7c0.3-0.2,0.7-0.4,1.2-0.4c0.5,0,0.9,0.1,1.2,0.4c0.2,0.1,0.3,0.3,0.5,0.6c0.2-0.3,0.5-0.6,0.8-0.7s0.7-0.2,1.1-0.2c0.8,0,1.4,0.3,1.7,0.9c0.2,0.3,0.2,0.8,0.2,1.3v4.2h-1.1v-4.4c0-0.4-0.1-0.7-0.3-0.9s-0.5-0.2-0.8-0.2c-0.4,0-0.8,0.1-1.1,0.4s-0.4,0.7-0.4,1.4v3.7h-1.1v-4.1c0-0.4-0.1-0.7-0.2-0.9c-0.2-0.3-0.5-0.4-0.9-0.4c-0.4,0-0.8,0.2-1.1,0.5s-0.5,0.9-0.5,1.7v3.3h-1.1V121.5z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M61.3,122.1c0.6,0.5,0.8,1.3,0.8,2.4c0,1-0.2,1.8-0.7,2.5c-0.5,0.7-1.2,1-2.3,1c-0.9,0-1.5-0.3-2-0.9c-0.5-0.6-0.8-1.4-0.8-2.4c0-1.1,0.3-1.9,0.8-2.5c0.5-0.6,1.2-0.9,2.1-0.9C60,121.3,60.7,121.5,61.3,122.1z M60.6,126.3c0.3-0.5,0.4-1.1,0.4-1.8c0-0.6-0.1-1.1-0.3-1.4c-0.3-0.6-0.8-0.9-1.5-0.9c-0.6,0-1.1,0.2-1.4,0.7c-0.3,0.5-0.4,1.1-0.4,1.8c0,0.7,0.1,1.2,0.4,1.7c0.3,0.4,0.8,0.7,1.4,0.7C59.9,127.1,60.3,126.8,60.6,126.3z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M63.3,119.1h1v3.1c0.2-0.3,0.5-0.5,0.8-0.7s0.7-0.2,1-0.2c0.8,0,1.4,0.3,1.9,0.8s0.7,1.3,0.7,2.4c0,1-0.2,1.8-0.7,2.5s-1.2,1-2,1c-0.5,0-0.9-0.1-1.2-0.3c-0.2-0.1-0.4-0.4-0.6-0.7v0.8h-1V119.1z M67.3,126.3c0.3-0.5,0.4-1.1,0.4-1.8c0-0.7-0.1-1.2-0.4-1.6s-0.7-0.7-1.3-0.7c-0.5,0-0.9,0.2-1.3,0.5c-0.4,0.4-0.5,0.9-0.5,1.8c0,0.6,0.1,1.1,0.2,1.4c0.3,0.7,0.8,1,1.6,1C66.6,127,67,126.8,67.3,126.3z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M70.1,119.1h1.1v1.2h-1.1V119.1z M70.1,121.5h1.1v6.2h-1.1V121.5z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M72.8,119.1h1.1v8.6h-1.1V119.1z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M79.3,121.6c0.4,0.2,0.7,0.5,0.9,0.8c0.2,0.3,0.3,0.7,0.4,1.1c0.1,0.3,0.1,0.8,0.1,1.4h-4.6c0,0.6,0.2,1.2,0.4,1.5c0.3,0.4,0.7,0.6,1.3,0.6c0.5,0,1-0.2,1.3-0.5c0.2-0.2,0.3-0.5,0.4-0.7h1c0,0.2-0.1,0.5-0.3,0.8s-0.3,0.5-0.5,0.7c-0.3,0.3-0.7,0.5-1.2,0.6c-0.3,0.1-0.5,0.1-0.9,0.1c-0.8,0-1.4-0.3-2-0.9c-0.5-0.6-0.8-1.4-0.8-2.4c0-1,0.3-1.8,0.8-2.5c0.5-0.6,1.3-0.9,2.1-0.9C78.4,121.3,78.9,121.4,79.3,121.6z M79.6,124.1c0-0.5-0.1-0.8-0.3-1.1c-0.3-0.5-0.8-0.8-1.4-0.8c-0.5,0-0.9,0.2-1.2,0.5s-0.5,0.8-0.5,1.3H79.6z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M38.4,137.5h1v0.9c0.2-0.3,0.5-0.5,0.7-0.7c0.3-0.2,0.7-0.4,1.2-0.4c0.5,0,0.9,0.1,1.2,0.4c0.2,0.1,0.3,0.3,0.5,0.6c0.2-0.3,0.5-0.6,0.8-0.7s0.7-0.2,1.1-0.2c0.8,0,1.4,0.3,1.7,0.9c0.2,0.3,0.2,0.8,0.2,1.3v4.2h-1.1v-4.4c0-0.4-0.1-0.7-0.3-0.9s-0.5-0.2-0.8-0.2c-0.4,0-0.8,0.1-1.1,0.4s-0.4,0.7-0.4,1.4v3.7h-1.1v-4.1c0-0.4-0.1-0.7-0.2-0.9c-0.2-0.3-0.5-0.4-0.9-0.4c-0.4,0-0.8,0.2-1.1,0.5s-0.5,0.9-0.5,1.7v3.3h-1.1V137.5z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M51.7,139.9c0.2,0,0.4-0.1,0.5-0.3c0-0.1,0.1-0.2,0.1-0.4c0-0.4-0.1-0.6-0.4-0.8c-0.3-0.2-0.6-0.2-1.1-0.2c-0.6,0-0.9,0.1-1.2,0.4c-0.1,0.2-0.2,0.4-0.3,0.7h-1c0-0.8,0.3-1.3,0.8-1.6c0.5-0.3,1-0.5,1.7-0.5c0.7,0,1.3,0.1,1.8,0.4c0.5,0.3,0.7,0.7,0.7,1.3v3.6c0,0.1,0,0.2,0.1,0.3s0.1,0.1,0.3,0.1c0,0,0.1,0,0.2,0s0.1,0,0.2,0v0.8c-0.2,0-0.3,0.1-0.4,0.1s-0.2,0-0.4,0c-0.4,0-0.6-0.1-0.8-0.4c-0.1-0.1-0.1-0.3-0.2-0.6c-0.2,0.3-0.5,0.5-0.9,0.7s-0.8,0.3-1.3,0.3c-0.6,0-1.1-0.2-1.4-0.5c-0.4-0.4-0.6-0.8-0.6-1.3c0-0.6,0.2-1,0.5-1.4s0.8-0.5,1.4-0.6L51.7,139.9z M49.5,142.8c0.2,0.2,0.5,0.3,0.8,0.3c0.4,0,0.7-0.1,1.1-0.3c0.6-0.3,0.9-0.8,0.9-1.4v-0.8c-0.1,0.1-0.3,0.2-0.5,0.2c-0.2,0.1-0.4,0.1-0.6,0.1l-0.6,0.1c-0.4,0.1-0.7,0.1-0.9,0.2c-0.3,0.2-0.5,0.5-0.5,0.9C49.2,142.4,49.3,142.6,49.5,142.8z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M59.2,137.8c0.4,0.3,0.7,0.9,0.8,1.8h-1c-0.1-0.4-0.2-0.7-0.4-1s-0.6-0.4-1.1-0.4c-0.7,0-1.2,0.3-1.4,1c-0.2,0.4-0.3,1-0.3,1.6c0,0.6,0.1,1.2,0.4,1.6s0.7,0.6,1.3,0.6c0.4,0,0.8-0.1,1-0.4c0.3-0.3,0.4-0.6,0.5-1.1h1c-0.1,0.8-0.4,1.4-0.9,1.8s-1.1,0.6-1.8,0.6c-0.8,0-1.5-0.3-2-0.9s-0.7-1.3-0.7-2.2c0-1.1,0.3-2,0.8-2.6s1.2-0.9,2-0.9C58.2,137.3,58.8,137.5,59.2,137.8z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M61.1,135.1h1.1v3.2c0.2-0.3,0.5-0.5,0.7-0.7c0.3-0.2,0.8-0.3,1.3-0.3c0.9,0,1.5,0.3,1.9,1c0.2,0.3,0.3,0.8,0.3,1.4v4h-1.1v-4c0-0.5-0.1-0.8-0.2-1c-0.2-0.3-0.6-0.5-1.1-0.5c-0.4,0-0.8,0.2-1.2,0.5s-0.5,0.9-0.5,1.7v3.3h-1.1V135.1z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M67.7,135.1h1.1v1.2h-1.1V135.1z M67.7,137.5h1.1v6.2h-1.1V137.5z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M70.4,137.5h1v0.9c0.3-0.4,0.6-0.6,0.9-0.8s0.7-0.2,1.1-0.2c0.9,0,1.5,0.3,1.8,0.9c0.2,0.3,0.3,0.8,0.3,1.5v4h-1.1v-4c0-0.4-0.1-0.7-0.2-0.9c-0.2-0.4-0.5-0.6-1-0.6c-0.2,0-0.5,0-0.6,0.1c-0.3,0.1-0.5,0.3-0.8,0.5c-0.2,0.2-0.3,0.4-0.3,0.6s-0.1,0.5-0.1,0.9v3.3h-1.1V137.5z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M80.9,137.6c0.4,0.2,0.7,0.5,0.9,0.8c0.2,0.3,0.3,0.7,0.4,1.1c0.1,0.3,0.1,0.8,0.1,1.4h-4.6c0,0.6,0.2,1.2,0.4,1.5c0.3,0.4,0.7,0.6,1.3,0.6c0.5,0,1-0.2,1.3-0.5c0.2-0.2,0.3-0.5,0.4-0.7h1c0,0.2-0.1,0.5-0.3,0.8s-0.3,0.5-0.5,0.7c-0.3,0.3-0.7,0.5-1.2,0.6c-0.3,0.1-0.5,0.1-0.9,0.1c-0.8,0-1.4-0.3-2-0.9c-0.5-0.6-0.8-1.4-0.8-2.4c0-1,0.3-1.8,0.8-2.5c0.5-0.6,1.3-0.9,2.1-0.9C80.1,137.3,80.5,137.4,80.9,137.6z M81.3,140.1c0-0.5-0.1-0.8-0.3-1.1c-0.3-0.5-0.8-0.8-1.4-0.8c-0.5,0-0.9,0.2-1.2,0.5s-0.5,0.8-0.5,1.3H81.3z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M83.8,137.5h1v1.1c0.1-0.2,0.3-0.5,0.6-0.8s0.7-0.5,1.1-0.5c0,0,0.1,0,0.1,0s0.1,0,0.2,0v1.1c-0.1,0-0.1,0-0.2,0s-0.1,0-0.2,0c-0.5,0-0.9,0.2-1.2,0.5s-0.4,0.7-0.4,1.2v3.6h-1.1V137.5z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M91.7,137.5h1.2c-0.1,0.4-0.5,1.3-1,2.8c-0.4,1.1-0.7,2-1,2.6c-0.6,1.6-1,2.6-1.3,2.9c-0.2,0.4-0.7,0.5-1.3,0.5c-0.1,0-0.3,0-0.3,0c-0.1,0-0.2,0-0.3-0.1v-1c0.2,0.1,0.3,0.1,0.4,0.1s0.2,0,0.2,0c0.2,0,0.3,0,0.4-0.1s0.2-0.1,0.2-0.2c0,0,0.1-0.2,0.2-0.5c0.1-0.3,0.2-0.5,0.3-0.6l-2.3-6.5h1.2l1.7,5.1L91.7,137.5z'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_2190_'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_2191_'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_2791_'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_6066_',
            'fill' : '#FDFCFF',
            'd' : 'M84,61.3v-5c0-0.6-0.5-1.1-1.1-1.1h-1.6c-0.6,0-1.1-0.5-1.1-1.1v-5c0-0.6-0.5-1.1-1.1-1.1h-5.3c-0.6,0-1.1,0.5-1.1,1.1v7.5c0,0.6,0.5,1.1,1.1,1.1h6.9c0.6,0,1.1,0.5,1.1,1.1v2.4c0,0.6,0.4,1,1,1.1l0,0C83.4,62.5,84,62,84,61.3z'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_6065_',
            'x' : '80.1',
            'y' : '60.2',
            'fill' : '#004A7A',
            'width' : '5.6',
            'height' : '13.2'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_6064_',
            'x' : '82.6',
            'y' : '64',
            'fill' : '#00B9ED',
            'width' : '7.2',
            'height' : '13.6'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_6063_',
            'x' : '89.9',
            'y' : '64',
            'fill' : '#FDFCFF',
            'width' : '7.2',
            'height' : '13.6'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_5083_',
            'x' : '93.4',
            'y' : '69.1',
            'fill' : '#00B9ED',
            'width' : '7.2',
            'height' : '6.2'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_5082_',
            'x' : '100.7',
            'y' : '69.1',
            'fill' : '#FDFCFF',
            'width' : '7.2',
            'height' : '6.2'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_5078_',
            'x' : '104.1',
            'y' : '69.1',
            'fill' : '#00B9ED',
            'width' : '7.2',
            'height' : '6.2'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_5076_',
            'x' : '111.4',
            'y' : '69.1',
            'fill' : '#FDFCFF',
            'width' : '7.2',
            'height' : '6.2'
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_5070_',
            'fill' : '#00B9ED',
            'points' : '78,74.9 78,70 84.6,70 84.6,74.8 '
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_5069_',
            'fill' : '#004A7A',
            'points' : '126.9,84.6 75.4,84.6 75.4,74.9 109.6,74.9 113.1,71.1 131.2,71.1 '
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_5066_',
            'x' : '80.8',
            'y' : '63.2',
            'fill' : '#00B9ED',
            'width' : '13',
            'height' : '2.3'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_3414_',
            'x' : '87',
            'y' : '63.1',
            'fill' : '#FDFCFF',
            'width' : '13',
            'height' : '2.6'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_2759_',
            'fill' : '#00B9ED',
            'd' : 'M111.3,70.6c0.5,0,1,0.4,1,1s-0.4,1-1,1h-2.3c-0.5,0-1-0.4-1-1s0.4-1,1-1H111.3z'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_1704_',
            'x' : '20.3',
            'y' : '71.7',
            'fill' : '#004A7A',
            'width' : '18.3',
            'height' : '3.4'
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_1701_',
            'fill' : '#00B9ED',
            'points' : '36.3,38.8 10.2,65 4.4,60.1 30.5,34 '
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_1700_',
            'fill' : '#00B9ED',
            'points' : '58.3,15.3 32.9,40.7 29.1,38.4 51.1,12.1 55,12.1 '
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_1693_',
            'x' : '-3.2',
            'y' : '46.8',
            'transform' : 'matrix(0.7071 -0.7071 0.7071 0.7071 -30.7011 26.1994)',
            'fill' : '#004A7A',
            'width' : '38.9',
            'height' : '6.8'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_1692_',
            'x' : '22.1',
            'y' : '24.1',
            'transform' : 'matrix(0.7071 -0.7071 0.7071 0.7071 -6.942 36.0399)',
            'fill' : '#004A7A',
            'width' : '35.9',
            'height' : '4.6'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_1688_'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_1691_',
            'fill' : '#004A7A',
            'd' : 'M57.3,74.2c-1.7,0-3.1,2-3.1,4.4c0,2.4,1.4,4.4,3.1,4.4h1.5c1.7,0,3.1-2,3.1-4.4c0-2.4-1.4-4.4-3.1-4.4H57.3z'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_1678_'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_1687_',
            'fill' : '#004A7A',
            'd' : 'M50.2,74.2c-1.7,0-3.1,2-3.1,4.4c0,2.4,1.4,4.4,3.1,4.4h1.5c1.7,0,3.1-2,3.1-4.4c0-2.4-1.4-4.4-3.1-4.4H50.2z'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_1665_'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_1668_',
            'fill' : '#004A7A',
            'd' : 'M17.5,74.2c-1.7,0-3.1,2-3.1,4.4c0,2.4,1.4,4.4,3.1,4.4H19c1.7,0,3.1-2,3.1-4.4c0-2.4-1.4-4.4-3.1-4.4H17.5z'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_1614_'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_1655_',
            'fill' : '#004A7A',
            'd' : 'M23.2,74.2c-1.7,0-3.1,2-3.1,4.4c0,2.4,1.4,4.4,3.1,4.4h1.5c1.7,0,3.1-2,3.1-4.4c0-2.4-1.4-4.4-3.1-4.4H23.2z'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_1600_'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_1606_',
            'fill' : '#004A7A',
            'd' : 'M28.8,74.2c-1.7,0-3.1,2-3.1,4.4c0,2.4,1.4,4.4,3.1,4.4h1.5c1.7,0,3.1-2,3.1-4.4c0-2.4-1.4-4.4-3.1-4.4H28.8z'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_1449_'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_1465_',
            'fill' : '#004A7A',
            'd' : 'M34.6,74.2c-1.7,0-3.1,2-3.1,4.4c0,2.4,1.4,4.4,3.1,4.4h1.5c1.7,0,3.1-2,3.1-4.4c0-2.4-1.4-4.4-3.1-4.4H34.6z'
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_1437_',
            'fill' : '#00B9ED',
            'points' : '51.8,80.1 69.8,80.1 69.8,76 66.6,67.5 48.6,67.5 38,74.6 12.1,74.6 '
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_1429_',
            'fill' : '#00B9ED',
            'points' : '23,62.7 27.5,67.2 27.5,71.3 10.3,71.3 10.3,67.6 16.3,67.6 12.7,62.7 '
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_1417_',
            'fill' : '#004A7A',
            'points' : '12.7,62.7 17.3,67.2 17.3,71.3 0,71.3 0,67.6 6,67.6 6,62.7 '
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_1416_',
            'fill' : '#004A7A',
            'points' : '1.3,80.1 51.8,80.1 51.8,76 48.6,67.5 27.2,67.5 27.2,72.8 1.3,72.8 '
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_1356_',
            'fill' : '#FDFCFF',
            'points' : '51.8,76 69.8,76 66.6,67.5 48.6,67.5 '
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_1186_'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_1278_',
            'fill' : '#004A7A',
            'd' : 'M46,74.2c-1.7,0-3.1,2-3.1,4.4c0,2.4,1.4,4.4,3.1,4.4h1.5c1.7,0,3.1-2,3.1-4.4c0-2.4-1.4-4.4-3.1-4.4H46z'
        }
    }, {
        'type' : 'ellipse',
        'properties' : {
            'id' : 'XMLID_1158_',
            'fill' : '#FDFCFF',
            'cx' : '45.7',
            'cy' : '78.5',
            'rx' : '1.3',
            'ry' : '2.1'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_1055_'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_1152_',
            'fill' : '#004A7A',
            'd' : 'M38.9,74.2c-1.7,0-3.1,2-3.1,4.4c0,2.4,1.4,4.4,3.1,4.4h1.5c1.7,0,3.1-2,3.1-4.4c0-2.4-1.4-4.4-3.1-4.4H38.9z'
        }
    }, {
        'type' : 'ellipse',
        'properties' : {
            'id' : 'XMLID_998_',
            'fill' : '#FDFCFF',
            'cx' : '38.6',
            'cy' : '78.5',
            'rx' : '1.3',
            'ry' : '2.1'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_956_'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_996_',
            'fill' : '#004A7A',
            'd' : 'M6.1,74.2c-1.7,0-3.1,2-3.1,4.4c0,2.4,1.4,4.4,3.1,4.4h1.5c1.7,0,3.1-2,3.1-4.4c0-2.4-1.4-4.4-3.1-4.4H6.1z'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_943_'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_944_',
            'fill' : '#004A7A',
            'd' : 'M11.9,74.2c-1.7,0-3.1,2-3.1,4.4c0,2.4,1.4,4.4,3.1,4.4h1.5c1.7,0,3.1-2,3.1-4.4c0-2.4-1.4-4.4-3.1-4.4H11.9z'
        }
    }, {
        'type' : 'ellipse',
        'properties' : {
            'id' : 'XMLID_941_',
            'fill' : '#FDFCFF',
            'cx' : '11.6',
            'cy' : '78.5',
            'rx' : '1.3',
            'ry' : '2.1'
        }
    }, {
        'type' : 'ellipse',
        'properties' : {
            'id' : 'XMLID_432_',
            'fill' : '#FDFCFF',
            'cx' : '5.6',
            'cy' : '78.5',
            'rx' : '1.3',
            'ry' : '2.1'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_927_'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_940_',
            'fill' : '#004A7A',
            'd' : 'M17.5,74.2c-1.7,0-3.1,2-3.1,4.4c0,2.4,1.4,4.4,3.1,4.4H19c1.7,0,3.1-2,3.1-4.4c0-2.4-1.4-4.4-3.1-4.4H17.5z'
        }
    }, {
        'type' : 'ellipse',
        'properties' : {
            'id' : 'XMLID_911_',
            'fill' : '#FDFCFF',
            'cx' : '17.2',
            'cy' : '78.5',
            'rx' : '1.3',
            'ry' : '2.1'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_880_'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_884_',
            'fill' : '#004A7A',
            'd' : 'M23.3,74.2c-1.7,0-3.1,2-3.1,4.4c0,2.4,1.4,4.4,3.1,4.4h1.5c1.7,0,3.1-2,3.1-4.4c0-2.4-1.4-4.4-3.1-4.4H23.3z'
        }
    }, {
        'type' : 'ellipse',
        'properties' : {
            'id' : 'XMLID_547_',
            'fill' : '#FDFCFF',
            'cx' : '23',
            'cy' : '78.5',
            'rx' : '1.3',
            'ry' : '2.1'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_497_',
            'x' : '54.2',
            'y' : '33.4',
            'fill' : '#004A7A',
            'width' : '7.5',
            'height' : '3.9'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_488_',
            'fill' : 'none',
            'stroke' : '#004A7A',
            'stroke-width' : '0.7731',
            'stroke-miterlimit' : '10',
            'd' : 'M55.3,46.6c0,1.5,1.2,2.6,2.6,2.6c1.5,0,2.6-1.2,2.6-2.6c0-1.5-1.2-2.6-2.6-2.6v-5.4'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_486_',
            'x' : '55.6',
            'y' : '36',
            'fill' : '#004A7A',
            'width' : '5',
            'height' : '5'
        }
    }, {
        'type' : 'circle',
        'properties' : {
            'id' : 'XMLID_485_',
            'fill' : '#004A7A',
            'cx' : '56.1',
            'cy' : '11.1',
            'r' : '3.1'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_484_',
            'fill' : '#004A7A',
            'd' : 'M56.1,8h3.6c1.7,0,3.1,1.4,3.1,3.1c0,1.7-1.4,3.1-3.1,3.1h-2.9L56.1,8z'
        }
    }, {
        'type' : 'line',
        'properties' : {
            'id' : 'XMLID_433_',
            'fill' : 'none',
            'stroke' : '#004A7A',
            'stroke-width' : '0.7731',
            'stroke-miterlimit' : '10',
            'x1' : '57.7',
            'y1' : '12',
            'x2' : '57.7',
            'y2' : '34.2'
        }
    }, {
        'type' : 'circle',
        'properties' : {
            'id' : 'XMLID_315_',
            'fill' : '#FDFCFF',
            'cx' : '54.8',
            'cy' : '78.1',
            'r' : '1.2'
        }
    }, {
        'type' : 'circle',
        'properties' : {
            'id' : 'XMLID_88_',
            'fill' : '#FDFCFF',
            'cx' : '66.9',
            'cy' : '78.1',
            'r' : '1.2'
        }
    }]
}, {// agriculture
    x : 650,
    x2 : 650,
    p : [{
        'type' : 'path',
        'properties' : {
            'class' : 'sources-active-area',
            'd' : 'M0,87.1c0-24.5,19.8-44.3,44.3-44.3s44.3,19.8,44.3,44.3H0z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M20.5,106.7c0.2,0,0.4-0.1,0.5-0.3c0-0.1,0.1-0.2,0.1-0.4c0-0.4-0.1-0.6-0.4-0.8c-0.3-0.2-0.6-0.2-1.1-0.2c-0.5,0-0.9,0.1-1.2,0.4c-0.1,0.2-0.2,0.4-0.3,0.7h-1c0-0.8,0.3-1.3,0.8-1.6s1-0.5,1.7-0.5c0.7,0,1.3,0.1,1.8,0.4c0.5,0.3,0.7,0.7,0.7,1.3v3.6c0,0.1,0,0.2,0.1,0.3s0.1,0.1,0.3,0.1c0,0,0.1,0,0.2,0s0.1,0,0.2,0v0.8c-0.2,0-0.3,0.1-0.4,0.1s-0.2,0-0.4,0c-0.4,0-0.6-0.1-0.8-0.4c-0.1-0.1-0.1-0.3-0.2-0.6c-0.2,0.3-0.5,0.5-0.9,0.7s-0.8,0.3-1.3,0.3c-0.6,0-1.1-0.2-1.4-0.5c-0.4-0.4-0.6-0.8-0.6-1.3c0-0.6,0.2-1,0.5-1.4c0.4-0.3,0.8-0.5,1.4-0.6L20.5,106.7z M18.2,109.5c0.2,0.2,0.5,0.3,0.8,0.3c0.4,0,0.7-0.1,1.1-0.3c0.6-0.3,0.9-0.8,0.9-1.4v-0.8c-0.1,0.1-0.3,0.2-0.5,0.2s-0.4,0.1-0.6,0.1l-0.6,0.1c-0.4,0.1-0.7,0.1-0.9,0.2c-0.3,0.2-0.5,0.5-0.5,0.9C17.9,109.1,18,109.4,18.2,109.5z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M27.3,104.5c0.2,0.1,0.4,0.3,0.6,0.6v-0.8h1v5.7c0,0.8-0.1,1.4-0.4,1.9c-0.4,0.9-1.3,1.3-2.5,1.3c-0.7,0-1.2-0.2-1.7-0.5c-0.5-0.3-0.7-0.8-0.8-1.4h1.1c0.1,0.3,0.2,0.5,0.3,0.7c0.2,0.2,0.6,0.4,1.1,0.4c0.8,0,1.3-0.3,1.6-0.9c0.1-0.3,0.2-0.9,0.2-1.8c-0.2,0.3-0.5,0.6-0.8,0.7s-0.7,0.2-1.2,0.2c-0.7,0-1.3-0.2-1.8-0.7s-0.8-1.3-0.8-2.4c0-1.1,0.3-1.9,0.8-2.5s1.1-0.9,1.9-0.9C26.5,104.1,26.9,104.2,27.3,104.5z M27.4,105.6c-0.3-0.4-0.7-0.6-1.2-0.6c-0.7,0-1.2,0.3-1.5,1c-0.1,0.4-0.2,0.9-0.2,1.5c0,0.7,0.1,1.2,0.4,1.6c0.3,0.4,0.7,0.6,1.2,0.6c0.8,0,1.3-0.3,1.6-1c0.2-0.4,0.3-0.8,0.3-1.4C27.9,106.6,27.7,106,27.4,105.6z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M30.5,104.2h1v1.1c0.1-0.2,0.3-0.5,0.6-0.8s0.7-0.5,1.1-0.5c0,0,0.1,0,0.1,0s0.1,0,0.2,0v1.1c-0.1,0-0.1,0-0.2,0s-0.1,0-0.2,0c-0.5,0-0.9,0.2-1.2,0.5s-0.4,0.7-0.4,1.2v3.6h-1.1V104.2z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M34.4,101.9h1.1v1.2h-1.1V101.9z M34.4,104.2h1.1v6.2h-1.1V104.2z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M41.2,104.6c0.4,0.3,0.7,0.9,0.8,1.8h-1c-0.1-0.4-0.2-0.7-0.4-1S40,105,39.5,105c-0.7,0-1.2,0.3-1.4,1c-0.2,0.4-0.3,1-0.3,1.6c0,0.6,0.1,1.2,0.4,1.6c0.3,0.4,0.7,0.6,1.3,0.6c0.4,0,0.8-0.1,1-0.4s0.4-0.6,0.5-1.1h1c-0.1,0.8-0.4,1.4-0.9,1.8s-1.1,0.6-1.8,0.6c-0.8,0-1.5-0.3-2-0.9s-0.7-1.3-0.7-2.2c0-1.1,0.3-2,0.8-2.6s1.2-0.9,2-0.9C40.2,104,40.8,104.2,41.2,104.6z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M44.2,104.2v4.2c0,0.3,0,0.6,0.1,0.8c0.2,0.4,0.5,0.6,1,0.6c0.7,0,1.2-0.3,1.5-1c0.1-0.4,0.2-0.8,0.2-1.4v-3.1h1.1v6.3h-1l0-0.9c-0.1,0.2-0.3,0.4-0.5,0.6c-0.4,0.3-0.9,0.5-1.4,0.5c-0.9,0-1.5-0.3-1.8-0.9c-0.2-0.3-0.3-0.7-0.3-1.3v-4.3H44.2z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M49.8,101.9h1.1v8.6h-1.1V101.9z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M52.7,102.5h1.1v1.8h1v0.9h-1v4.1c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0.1,0.4,0.1c0.1,0,0.1,0,0.2,0s0.1,0,0.2,0v0.8c-0.1,0-0.2,0.1-0.4,0.1s-0.3,0-0.4,0c-0.5,0-0.8-0.1-1-0.4s-0.3-0.6-0.3-1v-4.2h-0.8v-0.9h0.8V102.5z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M56.8,104.2v4.2c0,0.3,0,0.6,0.1,0.8c0.2,0.4,0.5,0.6,1,0.6c0.7,0,1.2-0.3,1.5-1c0.1-0.4,0.2-0.8,0.2-1.4v-3.1h1.1v6.3h-1l0-0.9c-0.1,0.2-0.3,0.4-0.5,0.6c-0.4,0.3-0.9,0.5-1.4,0.5c-0.9,0-1.5-0.3-1.8-0.9c-0.2-0.3-0.3-0.7-0.3-1.3v-4.3H56.8z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M62.5,104.2h1v1.1c0.1-0.2,0.3-0.5,0.6-0.8s0.7-0.5,1.1-0.5c0,0,0.1,0,0.1,0s0.1,0,0.2,0v1.1c-0.1,0-0.1,0-0.2,0s-0.1,0-0.2,0c-0.5,0-0.9,0.2-1.2,0.5s-0.4,0.7-0.4,1.2v3.6h-1.1V104.2z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M70.3,104.4c0.4,0.2,0.7,0.5,0.9,0.8c0.2,0.3,0.3,0.7,0.4,1.1c0.1,0.3,0.1,0.8,0.1,1.4h-4.6c0,0.6,0.2,1.2,0.4,1.5c0.3,0.4,0.7,0.6,1.3,0.6c0.5,0,1-0.2,1.3-0.5c0.2-0.2,0.3-0.5,0.4-0.7h1c0,0.2-0.1,0.5-0.3,0.8s-0.3,0.5-0.5,0.7c-0.3,0.3-0.7,0.5-1.2,0.6c-0.3,0.1-0.5,0.1-0.9,0.1c-0.8,0-1.4-0.3-2-0.9c-0.5-0.6-0.8-1.4-0.8-2.4c0-1,0.3-1.8,0.8-2.5c0.5-0.6,1.3-0.9,2.1-0.9C69.5,104.1,69.9,104.2,70.3,104.4z M70.7,106.9c0-0.5-0.1-0.8-0.3-1.1c-0.3-0.5-0.8-0.8-1.4-0.8c-0.5,0-0.9,0.2-1.2,0.5c-0.3,0.3-0.5,0.8-0.5,1.3H70.7z'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_6245_'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_6264_',
            'fill' : '#00B9ED',
            'd' : 'M65.8,67c4,4,2.4,11.9,2.4,11.9s-7.9,1.5-11.9-2.4c-4-4-2.4-11.9-2.4-11.9S61.9,63,65.8,67z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_6263_',
            'fill' : '#FDFCFF',
            'd' : 'M68.3,78.8c0,0-7.9,1.5-11.9-2.4c-4-4-2.4-11.9-2.4-11.9L68.3,78.8z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_6262_',
            'fill' : '#00B9ED',
            'd' : 'M75.8,67c4-4,11.9-2.4,11.9-2.4s1.5,7.9-2.4,11.9c-4,4-11.9,2.4-11.9,2.4S71.8,70.9,75.8,67z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_6261_',
            'fill' : '#FDFCFF',
            'd' : 'M87.6,64.5c0,0,1.5,7.9-2.4,11.9c-4,4-11.9,2.4-11.9,2.4L87.6,64.5z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_6260_',
            'fill' : '#00B9ED',
            'd' : 'M67.1,53.8c3,3,1.8,8.9,1.8,8.9S63,63.9,60,60.9c-3-3-1.8-8.9-1.8-8.9S64.1,50.9,67.1,53.8z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_6259_',
            'fill' : '#FDFCFF',
            'd' : 'M68.9,62.7c0,0-5.9,1.1-8.9-1.8c-3-3-1.8-8.9-1.8-8.9L68.9,62.7z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_6258_',
            'fill' : '#00B9ED',
            'd' : 'M74.5,53.8c3-3,8.9-1.8,8.9-1.8s1.1,5.9-1.8,8.9s-8.9,1.8-8.9,1.8S71.5,56.8,74.5,53.8z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_6257_',
            'fill' : '#FDFCFF',
            'd' : 'M83.4,52c0,0,1.1,5.9-1.8,8.9s-8.9,1.8-8.9,1.8L83.4,52z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_6256_',
            'fill' : '#00B9ED',
            'd' : 'M68.4,42.7c1.9,1.9,1.2,5.8,1.2,5.8s-3.8,0.7-5.8-1.2c-1.9-1.9-1.2-5.8-1.2-5.8S66.5,40.8,68.4,42.7z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_6255_',
            'fill' : '#FDFCFF',
            'd' : 'M69.6,48.4c0,0-3.8,0.7-5.8-1.2c-1.9-1.9-1.2-5.8-1.2-5.8L69.6,48.4z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_6254_',
            'fill' : '#00B9ED',
            'd' : 'M73.2,42.7c1.9-1.9,5.8-1.2,5.8-1.2s0.7,3.8-1.2,5.8c-1.9,1.9-5.8,1.2-5.8,1.2S71.3,44.6,73.2,42.7z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_6251_',
            'fill' : '#FDFCFF',
            'd' : 'M78.9,41.5c0,0,0.7,3.8-1.2,5.8c-1.9,1.9-5.8,1.2-5.8,1.2L78.9,41.5z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_6250_',
            'fill' : '#00B9ED',
            'd' : 'M68.4,33.9c1.9,1.9,1.2,5.8,1.2,5.8s-3.8,0.7-5.8-1.2c-1.9-1.9-1.2-5.8-1.2-5.8S66.5,32,68.4,33.9z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_6249_',
            'fill' : '#FDFCFF',
            'd' : 'M69.6,39.7c0,0-3.8,0.7-5.8-1.2c-1.9-1.9-1.2-5.8-1.2-5.8L69.6,39.7z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_6248_',
            'fill' : '#00B9ED',
            'd' : 'M73.2,33.9c1.9-1.9,5.8-1.2,5.8-1.2s0.7,3.8-1.2,5.8c-1.9,1.9-5.8,1.2-5.8,1.2S71.3,35.9,73.2,33.9z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_6247_',
            'fill' : '#FDFCFF',
            'd' : 'M78.9,32.8c0,0,0.7,3.8-1.2,5.8c-1.9,1.9-5.8,1.2-5.8,1.2L78.9,32.8z'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_6246_',
            'x' : '69.9',
            'y' : '46.4',
            'fill' : '#004A7A',
            'width' : '1.8',
            'height' : '37'
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_2149_',
            'fill' : '#00B9ED',
            'points' : '53.9,85.5 20.9,85.5 20.9,78.9 40.8,63.8 53.9,78.9'
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_1992_',
            'fill' : '#004A7A',
            'points' : '27.3,85.5 0.7,85.5 0.7,78.9 14.2,63.8 27.3,78.9'
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_1964_',
            'fill' : '#FDFCFF',
            'points' : '53.9,78.9 27.3,78.9 14.2,63.8 40.8,63.8'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_1957_',
            'fill' : '#004A7A',
            'd' : 'M32.7,61.5c0-3,2.4-5.4,5.4-5.4c3,0,5.4,2.4,5.4,5.4v14c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4V61.5z'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_1956_',
            'x' : '34',
            'y' : '73.3',
            'fill' : '#004A7A',
            'width' : '1.5',
            'height' : '12.6'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_1953_',
            'x' : '37.5',
            'y' : '73.3',
            'fill' : '#004A7A',
            'width' : '1.5',
            'height' : '12.6'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_1951_',
            'x' : '40.6',
            'y' : '73.3',
            'fill' : '#004A7A',
            'width' : '1.5',
            'height' : '12.6'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_1950_',
            'x' : '9',
            'y' : '80.2',
            'fill' : '#00B9ED',
            'width' : '11.1',
            'height' : '4.5'
        }
    }]
}, {// other
    x : 750,
    x2 : 750,
    p : [{
        'type' : 'path',
        'properties' : {
            'class' : 'sources-active-area',
            'd' : 'M0,85.9c0-24.5,19.8-44.3,44.3-44.3s44.3,19.8,44.3,44.3H0z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_815_',
            'fill' : '#FDFCFF',
            'd' : 'M46,62.1h23.1c0.5,0,0.9-0.4,0.9-0.9l0,0c0-0.5-0.4-0.9-0.9-0.9H65c-0.5,0-0.9-0.4-0.9-0.9v-5.2c0-0.5-0.4-0.9-0.9-0.9h-7.5c-0.5,0-0.9,0.4-0.9,0.9v1.6c0,0.5-0.4,0.9-0.9,0.9h-3.1c-0.5,0-0.9,0.4-0.9,0.9v0.8c0,0.5-0.4,0.9-0.9,0.9h-3c-0.5,0-1,0.5-0.9,1l0.1,1C45.2,61.7,45.6,62.1,46,62.1z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_704_',
            'fill' : '#FDFCFF',
            'd' : 'M19.5,50.6h23.1c0.5,0,0.9-0.4,0.9-0.9l0,0c0-0.5-0.4-0.9-0.9-0.9h-4.1c-0.5,0-0.9-0.4-0.9-0.9v-5.2c0-0.5-0.4-0.9-0.9-0.9h-7.5c-0.5,0-0.9,0.4-0.9,0.9v1.6c0,0.5-0.4,0.9-0.9,0.9h-3.1c-0.5,0-0.9,0.4-0.9,0.9v0.8c0,0.5-0.4,0.9-0.9,0.9h-3c-0.5,0-1,0.5-0.9,1l0.1,1C18.7,50.2,19.1,50.6,19.5,50.6z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_546_',
            'fill' : '#00B9ED',
            'd' : 'M24.3,79.3h32.7c0.7,0,1.3-0.6,1.3-1.3l0,0c0-0.7-0.6-1.3-1.3-1.3h-5.9c-0.7,0-1.3-0.6-1.3-1.3v-7.3c0-0.7-0.6-1.3-1.3-1.3H37.9c-0.7,0-1.3,0.6-1.3,1.3v2.2c0,0.7-0.6,1.3-1.3,1.3H31c-0.7,0-1.3,0.6-1.3,1.3v1.1c0,0.7-0.6,1.3-1.3,1.3h-4.3c-0.8,0-1.3,0.6-1.3,1.4l0.1,1.5C23.1,78.7,23.6,79.3,24.3,79.3z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M35.8,104.9c0.6,0.5,0.8,1.3,0.8,2.4c0,1-0.2,1.8-0.7,2.5c-0.5,0.7-1.2,1-2.3,1c-0.9,0-1.5-0.3-2-0.9c-0.5-0.6-0.8-1.4-0.8-2.4c0-1.1,0.3-1.9,0.8-2.5c0.5-0.6,1.2-0.9,2.1-0.9C34.6,104.1,35.3,104.4,35.8,104.9z M35.2,109.1c0.3-0.5,0.4-1.1,0.4-1.8c0-0.6-0.1-1.1-0.3-1.4c-0.3-0.6-0.8-0.9-1.5-0.9c-0.6,0-1.1,0.2-1.4,0.7c-0.3,0.5-0.4,1.1-0.4,1.8c0,0.7,0.1,1.2,0.4,1.7s0.7,0.7,1.4,0.7C34.4,109.9,34.9,109.6,35.2,109.1z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M38.2,102.6h1.1v1.8h1v0.9h-1v4.1c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0.1,0.4,0.1c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0v0.8c-0.1,0-0.2,0.1-0.4,0.1s-0.3,0-0.4,0c-0.5,0-0.8-0.1-1-0.4s-0.3-0.6-0.3-1v-4.2h-0.8v-0.9h0.8V102.6z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M41.3,101.9h1.1v3.2c0.2-0.3,0.5-0.5,0.7-0.7c0.3-0.2,0.8-0.3,1.3-0.3c0.9,0,1.5,0.3,1.9,1c0.2,0.3,0.3,0.8,0.3,1.4v4h-1.1v-4c0-0.5-0.1-0.8-0.2-1c-0.2-0.3-0.6-0.5-1.1-0.5c-0.4,0-0.8,0.2-1.2,0.5s-0.5,0.9-0.5,1.7v3.3h-1.1V101.9z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M51.8,104.5c0.4,0.2,0.7,0.5,0.9,0.8c0.2,0.3,0.3,0.7,0.4,1.1c0.1,0.3,0.1,0.8,0.1,1.4h-4.6c0,0.6,0.2,1.2,0.4,1.5c0.3,0.4,0.7,0.6,1.3,0.6c0.5,0,1-0.2,1.3-0.5c0.2-0.2,0.3-0.5,0.4-0.7h1c0,0.2-0.1,0.5-0.3,0.8s-0.3,0.5-0.5,0.7c-0.3,0.3-0.7,0.5-1.2,0.6c-0.3,0.1-0.5,0.1-0.9,0.1c-0.8,0-1.4-0.3-2-0.9c-0.5-0.6-0.8-1.4-0.8-2.4c0-1,0.3-1.8,0.8-2.5c0.5-0.6,1.3-0.9,2.1-0.9C51,104.2,51.4,104.3,51.8,104.5z M52.2,106.9c0-0.5-0.1-0.8-0.3-1.1c-0.3-0.5-0.8-0.8-1.4-0.8c-0.5,0-0.9,0.2-1.2,0.5c-0.3,0.3-0.5,0.8-0.5,1.3H52.2z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M54.7,104.3h1v1.1c0.1-0.2,0.3-0.5,0.6-0.8s0.7-0.5,1.1-0.5c0,0,0.1,0,0.1,0s0.1,0,0.2,0v1.1c-0.1,0-0.1,0-0.2,0s-0.1,0-0.2,0c-0.5,0-0.9,0.2-1.2,0.5s-0.4,0.7-0.4,1.2v3.6h-1.1V104.3z'
        }
    }]
}];

export default sources;